import { Add, Cancel, CheckCircle, Edit, Remove } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import HelpIcon from '@mui/icons-material/Help';
import { Button, Grid, IconButton, Typography } from '@mui/material';
import dayjs from 'dayjs';
import React from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import strings from '../Globalization/index';
import consts from '../consts';
import PrintProperties from '../views/PrintProperties';
import connectionService from '../services/Connection';
import promiseUtils from './promiseUtils';

dayjs.extend(isSameOrBefore);
let isBrowser = document.URL.indexOf('http://') > -1 || document.URL.indexOf('https://') > -1;
let iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
const defaultTemplate = /{((\w+)\.)?(\w+)}/gm;
const currentDate = dayjs();
const timeRegex = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/; // Regular expression to match time in 24-hour format (HH:mm:ss)
const renderElement = function (html) {
}
const { codeType, adminModuleUserType } = consts;
const rolesArray = [consts.RoleName.SuperAdmin, consts.RoleName.STERISSpecialist, consts.RoleName.Supervisor];

const toCamelCase = function (str) {
	str = str[0].toLowerCase() + str.substr(1);
	return str.replace(/([-_][a-z])/g, function (group) {
		return group.toUpperCase().replace('-', '').replace('_', '');
	}).replace(/ /g, '');
};

const urlFormat = /((http|https):\/\/)(www.)?[a-zA-Z0-9@:%._\+~#?&/=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%._\+~#?&/=]*)/g

const printProperties = new PrintProperties();
const rolesAllowedToModify = ["steris admin", "superadmin", "supervisor", "steris specialist", "physician admin"];
const hasElementType = typeof Element !== 'undefined';
const hasMap = typeof Map === 'function';
const hasSet = typeof Set === 'function';
const hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
const deepEqual = (a, b) => {
	if (a === b) return true;

	if (a && b && typeof a === 'object' && typeof b === 'object') {
		if (a.constructor !== b.constructor) return false;

		let length, i, keys;
		if (Array.isArray(a)) {
			length = a.length;
			if (length !== b.length) return false;
			for (i = length; i-- !== 0;) if (!deepEqual(a[i], b[i])) return false;
			return true;
		}
		let it;
		if (hasMap && a instanceof Map && b instanceof Map) {
			if (a.size !== b.size) return false;
			it = a.entries();
			while (!(i = it.next()).done) if (!b.has(i.value[0])) return false;
			it = a.entries();
			while (!(i = it.next()).done) if (!deepEqual(i.value[1], b.get(i.value[0]))) return false;
			return true;
		}
		if (a instanceof File || b instanceof File) {
			return a?.name === b?.name && a?.size === b?.size
		}

		if (hasSet && a instanceof Set && b instanceof Set) {
			if (a.size !== b.size) return false;
			it = a.entries();
			while (!(i = it.next()).done) if (!b.has(i.value[0])) return false;
			return true;
		}
		if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
			length = a.length;
			if (length !== b.length) return false;
			for (i = length; i-- !== 0;) if (a[i] !== b[i]) return false;
			return true;
		}

		if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
		if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
		if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

		keys = Object.keys(a);
		length = keys.length;
		if (length !== Object.keys(b).length) return false;

		for (i = length; i-- !== 0;) if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
		if (hasElementType && a instanceof Element) return false;
		for (i = length; i-- !== 0;) {
			if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
				continue;
			}
			if (!deepEqual(a[keys[i]], b[keys[i]])) return false;
		}
		return true;
	}

	return a !== a && b !== b;
};

const parseDate = (date, options = { utc: true }) => {
	if (date === null) {
		return '';
	}
	date = date.replace(/.*\{|\}.*/g, '');
	date = dayjs(date);
	if (date.isValid()) {
		if (options?.local) {
			date = date.clone().local();
		}
		if (options?.utc) {
			date = date.clone().utc();
		}
	}
	return date.getFullYear?.() > 2091 ? null : date.format(consts.MomentFormat.DateTimeFormatAMPM);
};
const fixDates = (value, options = { utc: true }) => {
	if (Array.isArray(value)) {
		for (const [k, v] of value.entries()) {
			if (typeof v === 'string' && v.startsWith('$D{')) {
				value[k] = parseDate(v, options);
			}
			if (typeof v === 'object' && v !== null && v !== undefined) {
				value[k] = fixDates(v, options);
			}
		}
	} else if (typeof value === 'object' && value !== null && value !== undefined) {
		for (const k of Object.keys(value)) {
			const v = value[k];
			if (typeof v === 'string' && v.startsWith('$D{')) {
				value[k] = parseDate(v, options);
			}
			if (typeof v === 'object' && v !== null && v !== undefined) {
				value[k] = fixDates(v, options);
			}
		}
	} else if (typeof value === 'string' && value.startsWith('$D{')) {
		value = parseDate(value, options);
	}

	return value;
}

export const hasEndoProduct = () => {
	const { loginData: { tags = {} } = {} } = util.localData;
	const { LicenseAppName } = tags;
	const result =  LicenseAppName.some(item => item.includes('catendo'));
	return result;
}

const util = {
	toCamelCase,
	deepEqual,
	/**
	 * @description Replaces the given tags in the given source with the given values.
	 * @param {string} source The source to replace the tags in.
	 * @param {object} values The values to replace the tags with.
	 * @param {object} options template - Regex to use for matching tags, keepMissingTags - Whether to keep tags that are not replaced.
	 * @returns {string} The source with the tags replaced.
	 * @example
	 * // Replaces all tags in the given source with the given values.
	 * console.log(template("${firstName} ${lastName}", { firstName: "John", lastName: "Doe" }));
	 * // -> "John Doe"
	 * // Two level tags are supported.
	 * console.log(template("${user.firstName} ${user.lastName}", { user: { firstName: "John", lastName: "Doe" } }));
	 * // -> "John Doe"
	 **/
	replaceTags: function (source, tags, { template = defaultTemplate, keepMissingTags = false } = {}) {
		if (!source || !tags) {
			return source;
		}

		return source.replace(template, function (match, g1, g2, g3) {
			const container = g2 ? tags[g2] || {} : tags;
			if (container[g3] === undefined) {
				return keepMissingTags ? match : '';
			}
			return container[g3];
		});
	},
	EUSterilizerData: {},
	isIOS: window.device ? window.device.platform === 'iOS' : iOS,
	isIE: /*@cc_on!@*/ !!document.documentMode ,
	localData: {},
	getCommonFromArr(arr1, arr2) {
		return arr1.filter((value) => arr2.includes(value));
	},
	urlFormat(url) {
		return url.match(urlFormat);
	},
	isLicenseType: function (licenseName) {
		let licenseData = this.localData?.LicenseAppName;
		if (licenseData && licenseData.length > 0) {
			return licenseData.includes(licenseName);
		}
		return false;
	},

	/**
	 * @desc - compares versions
	 * @param {string} v1  - live app version info
	 * @param {string} v2  - local app version info
	 */
	versionCompare: function (v1 = '', v2 = '') {
		const v1parts = v1.split('.'),
			v2parts = v2.split('.');

		for (let i = 0; i < Math.max(v1parts.length, v2parts.length); i++) {
			const v1part = Number(v1parts[i] || 0),
				v2part = Number(v2parts[i] || 0);
			if (v1part > v2part) {
				return 1;
			} else if (v1part < v2part) {
				return -1;
			}
		}

		return 0;
	},

	isCatSyncVersion: function (version) {
		if (!this.localData.loginData) return false;
		const catSyncVersion = this.localData.loginData.tags.CatSyncVersion;
		const isVersion = this.versionCompare(catSyncVersion, version);
		return isVersion === 1 || isVersion === 0;
	},

	GetViewerVideoList() {
		return {
			NavigatingToDashboard: { Index: 1, videoName: 'Navigating the Dashboard.mp4' },
			LookingUpEquipment: { Index: 2, videoName: 'Looking up Equipment.mp4' },
			DocumentingATest: { Index: 3, videoName: 'Documenting a Test BI.mp4' },
			DocumentingAControl: { Index: 4, videoName: 'Documenting a Control BI.mp4' },
			RecordingAReusableTestPack: { Index: 5, videoName: 'Recording a Test Pack.mp4' },
			AddingANewLotOfIndicators: { Index: 6, videoName: 'Adding New Indicators.mp4' },
			AccessingAndReviewingCycleDetails: { Index: 7, videoName: 'Accessing and Reviewing Cycle Details.mp4' },
			CompletingATask: { Index: 8, videoName: 'Completing a Task.mp4' },
			AttachingAFile: { Index: 9, videoName: 'Attaching a File.mp4' }
		};
	},
	getEndoVideoList() {
		return {
			Endomanagementoverview: { Index: 11, videoName: 'EndoManagement.mp4' }
		}
	},
	processGridState(listPrefToSave) {
		for (let rec in listPrefToSave) {
			switch (rec) {
				case 'json':
				case 'rows':
				case 'combos':
				case 'totalRecords':
				case 'selectedRowIndex':
				case 'loadingMessage':
				case 'activeRecord':
				case 'showPrefWin':
				case 'gridPreference':
				case 'baseFilters':
				case 'openPopUp':
				case 'loading':
				case 'toggleFilter':
				case 'column':
				case 'modalIsOpen':
				case 'xmlPopupValue':
				case 'xmlEditorValue':
					delete listPrefToSave[rec];
					break;
				case 'columns':
					let col = [];
					listPrefToSave[rec] &&
						listPrefToSave[rec].forEach(function (column) {
							for (let info in column) {
								switch (info) {
									case 'width':
									case 'resizable':
									case 'filterable':
									case 'cellClass':
									case 'sortable':
									case 'name':
										delete column[info];
										break;
									default:
									break;
								}
							}
							col.push(column);
						});
					listPrefToSave[rec] = col;
					break;
					default:
					break;
			}
		}
		return listPrefToSave;
	},

	clone(obj) {
		let clonedObjectsArray = [];
		let originalObjectsArray = []; //used to remove the unique ids when finished
		let nextObjId = 0;

		function objectId(obj) {
			if (obj === null) return null;
			if (obj.__obj_id === undefined) {
				obj['__obj_id'] = nextObjId++;
				originalObjectsArray[obj.__obj_id] = obj;
			}
			return obj.__obj_id;
		}

		function cloneRecursive(obj) {
			if (null === obj || typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean') return obj;

			// Handle Date
			if (obj instanceof Date) {
				const copy = new Date();
				copy.setTime(obj.getTime());
				return copy;
			}

			// Handle Array
			if (obj instanceof Array) {
				const copy = [];
				for (let i = 0; i < obj.length; ++i) {
					copy[i] = cloneRecursive(obj[i]);
				}
				return copy;
			}

			// Handle Object
			if (obj instanceof Object) {
				if (clonedObjectsArray[objectId(obj)] !== undefined) return clonedObjectsArray[objectId(obj)];

				let copy;
				if (obj instanceof Function)
					//Handle Function
					copy = function () {
						return obj.apply(this, arguments);
					};
				else copy = {};

				clonedObjectsArray[objectId(obj)] = copy;

				for (let attr in obj)
					if (attr !== '__obj_id' && obj.hasOwnProperty(attr)) copy[attr] = cloneRecursive(obj[attr]);

				return copy;
			}

			throw new Error("Unable to copy obj! Its type isn't supported.");
		}
		let cloneObj = cloneRecursive(obj);

		//remove the unique ids
		for (let i = 0; i < originalObjectsArray.length; i++) {
			delete originalObjectsArray[i].__obj_id;
		}

		return cloneObj;
	},
	updateDefaultChartConfigLang(selectedChartGroup) {
		let config = {
			chartTitle: '',
			selectedChartValueField: ''
		};
		switch (selectedChartGroup) {
			case 'CycleStatus':
				config.chartTitle = strings.CycleStatus;
				config.selectedChartValueField = strings.CycleStatus;
				break;
			case 'OperatorName':
				config.chartTitle = strings.Operator;
				config.selectedChartValueField = strings.Operator;
				break;
			case 'CycleName':
				config.chartTitle = strings.CycleType;
				config.selectedChartValueField = strings.CycleType;
				break;
			case 'EquipmentName':
				config.chartTitle = strings.EquipmentList;
				config.selectedChartValueField = strings.EquipmentList;
				break;
			case 'EquipmentTypeName':
				config.chartTitle = strings.EquipmentType;
				config.selectedChartValueField = strings.EquipmentType;
				break;
			case 'CycleActionStatus':
				config.chartTitle = strings.ReviewStatus;
				config.selectedChartValueField = strings.ReviewStatus;
				break;
			case 'Day':
				config.chartTitle = strings.Day;
				config.selectedChartValueField = strings.Day;
				break;
			case 'Month':
				config.chartTitle = strings.Month;
				config.selectedChartValueField = strings.Month;
				break;
			case 'Week':
				config.chartTitle = strings.Week;
				config.selectedChartValueField = strings.Week;
				break;
			default:
				break;
		}
		return config;
	},
	changeToNextRoute(navigate, screen, subRoute, parent) {
		let urlHash = parent || window.location.pathname;
	},
	getDataFromValue(store, value, field) {
		let toReturn = null;
		if (store) {
			let index = store.getIndexBy(field || 'DisplayValue', value);
			toReturn = index >= 0 ? store[index] : toReturn;
		}
		return toReturn;
	},
	getDateTimeFormat(showSecond) {
		let timeConfig = this.checkConfigData('TimeFormatAccess');
		let dateConfig = this.checkConfigData('DateFormatAccess');
		let timeFormat =
			timeConfig === consts.TimeFormat.StandardFormat
				? showSecond
					? 'hh:mm:ss A'
					: 'hh:mm A'
				: showSecond
					? 'HH:mm:ss'
					: 'HH:mm';
		return {
			date: dateConfig,
			datetime: dateConfig + ' ' + timeFormat,
			time: timeFormat,
			'min_sec': 'mm:ss',
			isStandardFormat: timeConfig === consts.TimeFormat.StandardFormat,
			'hrs_min': consts.MomentFormat.TimeFormat
		};
	},
	getStartTimeAndFilter(filters, isForDate) {
		let tableFilters = {};
		let cycleFilter = [];
		if (filters !== undefined && filters !== '') {
			cycleFilter = JSON.parse(filters);
		}
		let filterStartDate = '';
		if (cycleFilter.length !== 0) {
			for (let i = 0; i < cycleFilter.length; i++) {
				if (
					(cycleFilter[i].operator === 'eq' && cycleFilter[i].property === 'CycleStart') ||
					(cycleFilter[i].operator === 'gt' && cycleFilter[i].property === 'CycleStart') ||
					(cycleFilter[i].operator === 'gt' && cycleFilter[i].property === 'CycleDateTime')
				) {
					filterStartDate = cycleFilter[i].value;
				}
				if (cycleFilter[i].operator === 'like') {
					cycleFilter[i].value = cycleFilter[i].value + '%';
				}
			}
			tableFilters.filters = JSON.stringify(cycleFilter);
		}
		if (filterStartDate) {
			let cycleDate = new Date();
			filterStartDate = isForDate
				? cycleDate.setDate(cycleDate.getDate() - 7)
				: new Date(cycleDate.getFullYear(), cycleDate.getMonth() - 1, 1); // If selected date if blank then sending last month 1 day
		}
		tableFilters.filterStartDate = filterStartDate;
		return tableFilters;
	},
	hideKeyboard: function () {
		let activeElement = document.activeElement;
		if (activeElement && typeof activeElement.blur === 'function') {
			activeElement.blur();
		}
	},
	calculatePercentage: function (maxValue, value) {
		return (value / maxValue) * 100;
	},
	setCookies: function (name, value, expires, path, domain, secure) {
		expires = expires === undefined ? null : expires;
		path = path === undefined ? '/' : path;
		domain = domain === undefined ? null : domain;
		secure = secure === undefined ? false : secure;
		document.cookie =
			name +
			'=' +
			escape(value) +
			(expires === null ? '' : '; expires=' + expires.toUTCString()) +
			(path === null ? '' : '; path=' + path) +
			(domain === null ? '' : '; domain=' + domain) +
			(secure === true ? '; secure' : '');
	},

	clearLocalStorage: function () {
		let removeList = [
			'loginData',
			'CycleApprovalAccess',
			'PerformanceMonitorAccess',
			'LeakTestAccess',
			'FlowCheckAccess',
			'PreWashAccess',
			'WashAccess',
			'RinseAccess',
			'DisinfectionAccess',
			'FinalRinseAccess',
			'LoadNumberFormat'
		];
		this.localData.isSessionExpired = true;
		let me = this;
		removeList.forEach(function (prop) {
			delete me.localData[prop];
		});
	},

	isReadOnly: function () {
		let toReturn = true;
		if (this.localData.loginData) {
			let tags = this.localData.loginData.tags;
			toReturn = tags.ReadOnly ? JSON.parse(tags.ReadOnly) : false;
		}
		return toReturn;
	},
	checkConfigData(field) {
		if (this.localData[field]) {
			return this.localData[field];
		} else if (this.localData.loginData) {
			let info = this.localData.loginData;
			return info.tags[field.replace('Access', '')];
		}
	},
	checkAccess(field) {
		if (this.localData.hasOwnProperty(field)) {
			return this.localData[field];
		}
		if (this.localData.loginData) {
			let info = this.localData.loginData;
			return Number(info.tags[field.replace('Access', '')]) !== 0;
		}
		return true;
	},

	getPasswordRegExp(field) {
		//All password field are configered from one place
		if (this.localData[field + 'Access']) {
			return this.localData[field + 'Access'];
		}
		if (this.localData.loginData) {
			let tags = this.localData.loginData.tags;
			return tags?.PasswordStrength;
		}
	},
	onLogout(callBack) {
		const me = this;
		const formData = new FormData();
		formData.append('signOut', true);
		fetch(connectionService.Login, {
			body: formData,
			method: 'POST',
			credentials: 'include'
		})
			.then((response) => {
				if (response.status === 200) {
					me.props.actions.logout();
					if (callBack && typeof callBack === 'function') {
						callBack('/login?isLogout=true');
					}
					localStorage.setItem('IsLoggedOut', true);
				}
			})
			.catch(function (err) {
				alert('Error logging out');
			});
	},

	comboRenderer: function (comboData, values, multiple) {
		let textValues = [];
		if (multiple === true) {
			values = values.split(',');
			for (let idx = 0, valueCount = values.length; idx < valueCount; idx++) {
				values[idx] = Number(values[idx]);
			}
		} else {
			values = [values];
		}
		for (let idx = 0, valueCount = values.length; idx < valueCount; idx++) {
			let value = values[idx];
			for (let i = 0, len = comboData.length; i < len; i++) {
				if (comboData[i].LookupId === value) {
					textValues.push(comboData[i].DisplayValue);
					break;
				}
			}
		}
		return textValues.join(', ');
	},

	checkConnection: function () {
		let networkState;
		if (navigator.network) {
			networkState = navigator.network.connection.type;
			let states = {};
			states[connectionService.UNKNOWN] = 'Unknown connection';
			states[connectionService.NONE] = 'No network connection';
			if (states[networkState] === states[connectionService.NONE] || states[networkState] === states[connectionService.NONE]) {
				return false;
			} else {
				return true;
			}
		}
		return true;
	},

	getPropertyValue: function (property, data, type) {
		if(!property) {
			return '';
		}
		let dataProperty = property.split('.');
		let toReturn = data || {};
		dataProperty.forEach((prop) => {
			toReturn = toReturn[Object.keys(toReturn).find((key) => key.toLowerCase() === prop.toLowerCase())] || '';
		});
		if(toReturn === 'isEmpty'){
			return '0';
		}
		switch (type) {
			case 'decimal':
				toReturn = Number(toReturn) && Number(toReturn).toFixed(3).toString() || 0;
				break;
			case 'hrs_min':
			case 'min_sec':
			case 'date':
				toReturn = toReturn ? fixDates(toReturn) : toReturn;
				break;
			case 'bool':
				toReturn = Boolean(toReturn);
				break;
			default:
				break;
		}
		return toReturn;
	},

	isBrowser: isBrowser,

	isNative: {
		Android: function () {
			return navigator.userAgent.match(/Android/i) === 'Android';
		},
		iOS: function () {
			return navigator.userAgent.match(/iPhone/i) === 'iPhone' || navigator.userAgent.match(/iPad/i) === 'iPad';
		}
	},

	getPlatform: function () {
		let deviceType =
			navigator.userAgent.match(/iPad/i) === 'iPad'
				? 'iPad'
				: navigator.userAgent.match(/iPhone/i) === 'iPhone'
					? 'iPhone'
					: navigator.userAgent.match(/Android/i) === 'Android'
						? 'Android'
						: null;
		return deviceType;
	},

	parseISOString(s) {
		if (s instanceof Date) return s;
		let b = s.split(/\D+/);
		return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5], b[6]));
	},

	dateRenderer: function (date) {
		if (date === null) {
			return '';
		}
		return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
	},
	formatDate: function (input) {
		if (input === null) {
			return '';
		}
		let date = new Date(
			input.slice(0, 4),
			input.slice(4, 6) - 1,
			input.slice(6, 8),
			input.slice(8, 10),
			input.slice(10, 12),
			input.slice(12, 14)
		);
		return this.dateRenderer(date);
	},
	parseDate,
	fixDates,
	continueSession(userName, password) {
		this.localData.isSessionExpired = false;
		let loginProps = {
			username: userName,
			password: password,
			rememberMe: true,
			timeZoneOffSet: new Date().getTimezoneOffset()
		};
		let formData = new FormData();
		for (let key in loginProps) {
			formData.append(key, loginProps[key]);
		}
		fetch(connectionService.Login, { method: 'POST', body: formData, credentials: 'include' })
			.then((response) => {
				response.text().then(function (text) {
					if (text && text.length > 0) {
						let json = this.unsafeJson(text);
						if (json.success) {
							window.location.reload();
						} else {
							if (json.message === 'AccountLocked') {
								Swal.fire({
									titleText: strings.Alert,
									text: strings.AccountLocked,
									closeOnConfirm: true,
									confirmButtonText: strings.Ok,
									allowOutsideClick: false
								}).then(() => {
									window.location.hash = '#/login';
								});
							} else {
								window.queuedScope._onSessionExpire(
									'',
									'',
									window.queuedScope,
									strings.ValidPasswordMessage
								);
							}
						}
					}
				});
			})
			.catch(function () { });
	},
	isdeskTopView: function () {
		return this.getPlatform() === 'iPad' || (!this.isNative.Android() && !this.isNative.iOS());
	},
	isIPad: function () {
		return this.getPlatform() === 'iPad';
	},
	onInputKeyDown(event) {
		event.preventDefault();
	},

	myJsonParse(value) {
		if (value) {
			return this.fixDates(value);
		}
		return {};
	},
	unsafeJson(value) {
		let nullDate = value.indexOf('00010101') !== -1 ? value.substr(value.indexOf('00010101'), 17) : null;
		if (nullDate) {
			value = value.replace(new RegExp(nullDate, 'g'), '').replace(/\$D\(\)/g, '""');
		}
		let $D = function (value) {
			value = value.toString();
			value = new Date(
				Number(value.substr(0, 4)),
				Number(value.substr(4, 2) - 1),
				Number(value.substr(6, 2)),
				Number(value.substr(8, 2)),
				Number(value.substr(10, 2)),
				Number(value.substr(12, 2))
			);
			return value.getFullYear() > 2091 ? null : dayjs(value).format(consts.MomentFormat.DateTimeFormatAMPM);
		};

		let result = value.length > 0 ? eval('(' + value + ')') : '';
		result = this.myJsonParse(result);
		return result;
	},
	openHelp(filename) {
		this.context.router.push({ pathname: 'helpform', query: { filename: filename } });
	},
	getParameterByName(name) {
		let url = window.location.href;
		name = name.replace(/[\[\]]/g, '\\$&');
		let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, ' '));
	},
	fetchRequest(options, callbackSuccess, callbackFailure) {
		let timeout = 30000;
		let me = this;
		let p = fetch(options.url, {
			method: 'POST',
			body: options.formData,
			credentials: 'include'
		});
		p = promiseUtils.makeCancelable(p, timeout);
		me.lastFetch = p;
		return p.promise
			.then((response) => {
				me.lastFetch = null;
				callbackSuccess(response);
			})
			.catch(function (err) {
				me.lastFetch = null;
				callbackFailure(err);
			});
	},
	getComboData(formData) {
		return fetch(connectionService.Combo, {
			method: 'POST',
			body: formData,
			credentials: 'include'
		})
			.then((response) => response.json())
			.then((json) => {
				json.records &&
					json.records.forEach((obj) => {
						Object.assign(obj, {
							value: obj.LookupId,
							label: obj.DisplayValue
						});
					});
				return json.records;
			});
	},
	savePreference(prefName, tableId, listPrefToSave, isDefault, prefDesc) {
		if (prefName) {
			Swal.fire({ titleText: strings.Alert, text: strings.RequiredMessage, confirmButtonText: strings.Ok, allowOutsideClick: false });
			return;
		}
		if (tableId !== null && tableId !== '') {
			let formData = new FormData();
			formData.append('id', tableId);
			formData.append('prefId', 0);
			formData.append('prefName', prefName);
			formData.append('isDefault', isDefault);
			formData.append('prefDesc', '');
			formData.append('prefValue', JSON.stringify(listPrefToSave));
			formData.append('action', 'save');
			this.savePreferenceRequest(formData);
		}
	},
	getDefaultComboParams(comboType, input) {
		let formData = new FormData();
		formData.append('start', 0);
		formData.append('comboType', comboType);
		formData.append('limit', 50);
		formData.append('asArray', 0);
		formData.append('search', input);
		return formData;
	},

	savePreferenceRequest(formData) {
		let timeout = 30000;
		let me = this;
		let p = fetch(connectionService.GridPreferenceManager, {
			method: 'POST',
			body: formData,
			credentials: 'include'
		});
		p = promiseUtils.makeCancelable(p, timeout);
		me.lastFetch = p;
		return p.promise
			.then((response) => {
				me.lastFetch = null;
				let json;
				if (response.status === 200) {
					response.text().then(function (text) {
						try {
							json = this.unsafeJson(text);
						} catch (e) {
							Swal.fire({ titleText: strings.ErrorTitle, text: strings.ErrorUpdate, icon: 'error', confirmButtonText: strings.Ok, allowOutsideClick: false });
							return;
						}
						if (json.success === false && json.message === strings.SessionExpiredResponse) {
							Swal.fire({ titleText: strings.ErrorTitle, text: strings.ErrorUpdate, icon: 'error', confirmButtonText: strings.Ok, allowOutsideClick: false });
							return;
						}
						 json = this.unsafeJson(text);
					});
				}
			})
			.catch(function (err) {
				me.lastFetch = null;
			});
	},
	loadGridPreference(tableId, scope, stateToSet, reloadFunction) {
		let timeout = 30000;
		if (tableId !== '') {
			let formData = new FormData();
			formData.append('id', tableId);
			formData.append('action', 'list');
			let me = this;
			let p = fetch(connectionService.GridPreferenceManager, {
				method: 'POST',
				body: formData,
				credentials: 'include'
			});
			p = promiseUtils.makeCancelable(p, timeout);
			me.lastFetch = p;
			return p.promise
				.then((response) => {
					const contentType = response.headers.get('content-type');
					if (contentType && contentType.indexOf('application/json') !== -1) {
						return response.json().then((text) => {
							me.lastFetch = null;
							if (response.status === 200) {
								response.text().then(function (text) {
									let json
									try {
										json= this.unsafeJson(text);
										if (!json.success) {
											if (json.info === 'Login failed' || json.info === 'Session has expired!') {
												//Its auto handel in ajaxApi.js
												return false;
											}
										}
									} catch (e) {
										Swal.fire({
											titleText: strings.ErrorTitle,
											text: strings.ErrorUpdate,
											icon: 'error',
											confirmButtonText: strings.Ok,
											allowOutsideClick: false
										});
										return false;
									}
									if (json.success === false && json.message === strings.SessionExpiredResponse) {
										Swal.fire({
											titleText: strings.ErrorTitle,
											text: strings.ErrorUpdate,
											icon: 'error',
											confirmButtonText: strings.Ok,
											allowOutsideClick: false
										});
										return false;
									}
									json = this.unsafeJson(text);
									if (json.preferences.length > 0) {
										scope.setState(
											{ [stateToSet]: JSON.parse(json.preferences[0].prefValue || '{}')[stateToSet] },
											function () {
												if (typeof reloadFunction === 'function') {
													reloadFunction();
												}
											}
										);
									}
								});
							}
						});
					} else {
						return response.text().then((text) => {
						});
					}
				})
				.catch(function (err) {
				});
		}
	},
	createComboStore(combo) {
		let options = [<option key="0" value="0" label="" />];
		(combo || []).forEach(function (items, index) {
			options.push(
				<option key={index + 1} value={items.LookupId} label={items.DisplayValue}>
					{items.DisplayValue}
				</option>
			);
		});
		return options;
	},
	bIResultRenderer({ row, value }) {
		let toReturn = null;
		let bIResultIcon = util.getBIResultIcon(row) || '';
		let equipmentTypeId = row?.EquipmentTypeId || 0;
		if (equipmentTypeId === consts.EquipmentType.INCUBATOR) {
			let color = bIResultIcon
				? bIResultIcon.indexOf('red') > -1
					? 'red'
					: bIResultIcon.indexOf('green') > -1
						? 'green'
						: 'orange'
				: null;
			let icon = color ? bIResultIcon.replace('-' + color, '') : null;
			if (bIResultIcon) {
				toReturn = (
					<div className="columnIcon">
						<i
							style={{
								fontSize: 28,
								color: color
							}}
							className={'fa ' + icon}
						/>{' '}
					</div>
				);
			}
			return toReturn;
		} else {
			return <div>{value || ''}</div>;
		}
	},
	getLabel(field) {
		if (!field.required) {
			return field.label;
		}
		return (
			<label className="control-label">
				<span>
					{field.label}
					<span style={{ color: 'red' }}> *</span>
				</span>
			</label>
		);
	},
	copyText(text) {
		let tempField = document.createElement('input');
		document.body.appendChild(tempField);
		tempField.value = text;
		tempField.select();
		document.execCommand('copy', false);
		tempField.remove();
	},
	reSetEUSterilizerData() {
		this.EUSterilizerData = {};
	},
	processSterilizerData(Obj) {
		for (let prop in Obj) {
			if (prop === 'Parameters') {
				Object.assign(this.EUSterilizerData, Obj[prop]);
			} else if (prop === 'PhaseResults') {
				Object.assign(this.EUSterilizerData, { [Obj.PhaseName + 'Results']: Obj[prop] });
			} else if (prop === 'PhaseTime') {
				Object.assign(this.EUSterilizerData, { [Obj.PhaseName + 'PhaseTime']: Obj[prop] });
			} else if (typeof Obj[prop] === 'object') {
				this.processSterilizerData(Obj[prop]);
			}
		}
	},
	proccessDependantValues: function (data, dependentOn) {
		let toReturn = true;
		if (dependentOn) {
			toReturn = dependentOn.filter((value) => this.getPropertyValue(value, data)).length !== 0;
		}
		return toReturn;
	},
	getXMLTagValue: (data, tagName) => data[Object.keys(data).find((key) => key.toLowerCase() === tagName.toLowerCase())],
	getProcessMonitoringStatus(data, propsData, extraProps) {
		if (!data) {
			return false;
		}
		if (data.XmlParameters) {
			this.reSetEUSterilizerData();
			this.processSterilizerData(JSON.parse(data.XmlParameters));
			data = Object.assign(data, this.EUSterilizerData);
		}
		let isLeakTest = !!data.MaxLeakRate;
		const { isSteamEU, isAMSCOEU, isGrid } = extraProps;
		for (let obj of propsData) {
			if (isLeakTest === !!obj.isLeakTest) {
				let showIndependentValue = !!obj.disableForAMSCOEU === !isAMSCOEU;
				let type = obj.type,
					isDateType = type === 'hrs_min' || type === 'min_sec' || type === 'date',
					metricDataProperty1 = obj.MetricString
						? obj.MetricString
						: obj.MetricDataProperty1
							? this.getPropertyValue(obj.MetricDataProperty1, data, type, isGrid)
							: '',
					metricDataProperty2 = obj.MetricDataProperty2
						? this.getPropertyValue(obj.MetricDataProperty2, data, type, isGrid)
						: '',
					actualDataProperty1 = obj.ActualDataProperty1
						? this.getPropertyValue(obj.ActualDataProperty1, data, type, isGrid)
						: '',
					actualDataProperty2 = obj.ActualDataProperty2
						? this.getPropertyValue(obj.ActualDataProperty2, data, type, isGrid)
						: '',
					controlProperty1 = obj.ControlProperty1
						? this.getPropertyValue(obj.ControlProperty1, data, type, isGrid)
						: '',
					controlProperty2 = obj.ControlProperty2
						? this.getPropertyValue(obj.ControlProperty2, data, type, isGrid)
						: '',
					independentProperty1 = obj.IndependentProperty1
						? this.getPropertyValue(obj.IndependentProperty1, data, type, isGrid)
						: '',
					independentProperty2 = obj.IndependentProperty2
						? this.getPropertyValue(obj.IndependentProperty2, data, type, isGrid)
						: '';
				const result =
					obj.AllowBlankMetic && !metricDataProperty1
						? true
						: obj.CriticalParameterIcon ||
						((data.CycleStatusId === consts.CycleStatus.Pass ||
							data.CycleStatusId === consts.CycleStatus.AdvantageCyclePass) &&
							this.getResultIcon(
								isDateType,
								obj.compareOperator,
								metricDataProperty1,
								actualDataProperty1,
								metricDataProperty2 || metricDataProperty1,
								actualDataProperty2 || actualDataProperty1,
								controlProperty1,
								showIndependentValue && independentProperty1,
								controlProperty2 || controlProperty1,
								showIndependentValue && (independentProperty2 || independentProperty1),
								type
							));
				if (
					!result ||
					(result === 'fa fa-times icon-times' &&
						!obj.isTitle &&
						(((metricDataProperty1 || obj.AllowBlankMetic) &&
							((isDateType &&
								((actualDataProperty1 && dayjs(actualDataProperty1) > consts.DateTime.MinDate) ||
									(controlProperty1 &&
										(dayjs(controlProperty1) > consts.DateTime.MinDate ||
											(type === 'hrs_min' &&
												dayjs(controlProperty1, consts.MomentFormat.TimeFormat).isValid()))))) ||
								(!isDateType && actualDataProperty1))) ||
							controlProperty1))
				) {
					return false;
				}
			}
		}
		return true;
	},
	getResultIcon(
		isDateType,
		operator,
		metric,
		actual,
		metricMax,
		actualMax,
		control,
		independent,
		controlMax,
		independentMax,
		type
	) {
		metric = isDateType
			? type === 'hrs_min'
				? /AM|PM|am|pm/i.test(metric)
					? dayjs(
						dayjs(metric, consts.MomentFormat.DateTimeFormatAMPM).format('HH:mm:ss'),
						consts.MomentFormat.TimeFormat
					).unix()
					: dayjs(metric, consts.MomentFormat.TimeFormat).unix()
				: dayjs(metric).unix()
			: type === 'bool' ? Boolean(metric) : Number(metric);
		actual = isDateType
			? type === 'hrs_min'
				? dayjs(control || actual, consts.MomentFormat.TimeFormat).unix()
				: dayjs(control || actual).unix()
			: type === 'bool' ? Boolean(metric) : Number(control || actual);
		metricMax = isDateType
			? type === 'hrs_min'
				? dayjs(metricMax, consts.MomentFormat.TimeFormat).unix()
				: dayjs(metricMax).unix()
			: type === 'bool' ? Boolean(metric) : Number(metricMax);
		actualMax = isDateType
			? type === 'hrs_min'
				? dayjs(controlMax || actualMax, consts.MomentFormat.TimeFormat).unix()
				: dayjs(controlMax || actualMax).unix()
			: type === 'bool' ? Boolean(metric) : Number(controlMax || actualMax);
		independent = isDateType
			? type === 'hrs_min'
				? dayjs(independent, consts.MomentFormat.TimeFormat).unix()
				: dayjs(independent).unix()
			: type === 'bool' ? Boolean(metric) : Number(independent);
		controlMax = isDateType
			? type === 'hrs_min'
				? dayjs(controlMax, consts.MomentFormat.TimeFormat).unix()
				: dayjs(controlMax).unix()
			: type === 'bool' ? Boolean(metric) : Number(controlMax);
		independentMax = isDateType
			? type === 'hrs_min'
				? dayjs(independentMax, consts.MomentFormat.TimeFormat).unix()
				: dayjs(independentMax).unix()
			: type === 'bool' ? Boolean(metric) : Number(independentMax);
		let resultIcon = false;
		switch (operator) {
			case 'gt':
				resultIcon = metric < actual;
				break;
			case 'bgt':
				resultIcon = metric < actual && metricMax < actual;
				break;
			case 'lt':
				resultIcon = metric > actual;
				break;
			case 'eq':
				resultIcon = metric === actual;
				break;
			case 'gtEq':
				resultIcon = metric <= actual;
				break;
			case 'ltEq':
				resultIcon = metric >= actual;
				break;
			case 'btw':
				resultIcon = metric <= actual && metricMax >= actualMax;
				break;
			case 'btwltEq':
				if (independent && independentMax) {
					resultIcon =
						metric <= actual && controlMax <= metricMax && metric <= independent && independentMax <= metricMax;
				} else {
					resultIcon = metric <= actual && controlMax <= metricMax;
				}
				break;
			case 'btwNotEq':
				resultIcon = metric < actual && metricMax >= actualMax;
				break;
			case 'notEqZero':
				resultIcon = actual !== 0;
				break;
			default:
			break;
		}
		return resultIcon ? 'fa fa-check icon-check' : !operator ? '' : 'fa fa-times icon-times';
	},

	getTimeResultIcon(operator, metric, actual) {
		let resultIcon = false;
		// Construct the full date-time strings by combining with the current date
		const metricDateTime = `${currentDate.format('YYYY-MM-DD')} ${metric}`;
		const actualDateTime = `${currentDate.format('YYYY-MM-DD')} ${actual}`;
		switch (operator) {
			case 'gt':
				resultIcon = dayjs(metric).isBefore(dayjs(actual));
				break;
			case 'gtEq':
				if (dayjs(metric).isValid()) {
					resultIcon = dayjs(metric).isSameOrBefore(dayjs(actual));
				} else if (timeRegex.test(metric)) {
					resultIcon = dayjs(metricDateTime).isSameOrBefore(dayjs(actualDateTime));
				}
				break;
			case 'lt':
				resultIcon = dayjs(actual).isBefore(dayjs(metric));
				break;
			default:
				break;
		}
		return resultIcon ? 'fa fa-check icon-check' : 'fa fa-times icon-times';
	},

	/*
	url - request URL
	options - Array of Object
	*/
	hiddenRequest(scope, url, options, type, fileName, showModel) {
		const me = this;
		scope.setState({ loading: true }, () => {
			let formData = new FormData();
			options.forEach((element, index) => {
				formData.append(element.Name, element.Value);
			});
			fetch(url, {
				method: 'POST',
				credentials: 'include',
				body: formData
			})
				.then((response) => response.blob())
				.then(function (response) {
					scope.setState({ loading: false });
					me.showFile(response, type, fileName, showModel);
				})
				.catch(function (error) {
					Swal.fire({ titleText: 'Error', text: error, icon: 'error', confirmButtonText: strings.Ok, allowOutsideClick: false });
				});
			let isSafariBrowser =
				navigator.appVersion.indexOf('Macintosh') > -1 &&
				navigator.appVersion.indexOf('Safari') > -1 &&
				navigator.appVersion.indexOf('Chrome') === -1;
			if (isSafariBrowser) {
				Swal.fire({
					titleText: 'Info',
					text: strings.FileHasBeenDownloadedPleaseCheckInTheDownloadsFolder,
					icon: 'info',
					confirmButtonText: strings.Ok,
					allowOutsideClick: false
				});
			}
		});
	},
	showFile(blob, type, fileName, showModel) {
		// It is necessary to create a new blob object with mime-type explicitly set
		// otherwise only Chrome works like it should
		let newBlob = new Blob([blob], { type: type });

		// IE doesn't allow using a blob object directly as link href
		// instead it is necessary to use msSaveOrOpenBlob
		if (window.navigator && window.navigator.msSaveOrOpenBlob) {
			window.navigator.msSaveOrOpenBlob(newBlob, fileName);
			return;
		}
		// For other browsers:
		// Create a link pointing to the ObjectURL containing the blob.
		const data = window.URL.createObjectURL(newBlob);
		let link = document.createElement('a');
		link.dataType = 'pdf';
		link.href = data;
		link.download = fileName;
		if (showModel) {
			let win = window.open(link, fileName, 'titlebar=1'),
				iframe = document.createElement('iframe'),
				title = document.createElement('title');
			title.appendChild(document.createTextNode(fileName));
			iframe.src = link;
			iframe.width = '100%';
			iframe.height = '100%';
			iframe.style.border = 'none';
			win.document.head.appendChild(title);
			win.document.body.appendChild(iframe);
			win.document.body.style.margin = 0;
			win.print();
		} else {
			link.click();
		}
		setTimeout(function () {
			// For Firefox it is necessary to delay revoking the ObjectURL
			window.URL.revokeObjectURL(data);
		}, 100);
	},
	getPumpType(value) {
		return value === consts.PumpType.None ? consts.PumpType.Pump0 : value;
	},
	getTitleInUpperCase(value, unit) {
		value = (value || '').split(' ');
		for (let valueIndex = 0, valueLength = value.length; valueIndex < valueLength; valueIndex++) {
			if (/AM|PM/i.test(value[valueIndex])) {
				continue;
			}
			value[valueIndex] = value[valueIndex]
				? value[valueIndex][0]?.toUpperCase() + value[valueIndex]?.substr(1)?.toLowerCase()
				: value[valueIndex];
		}
		return `${value?.join(' ')}` + (unit ? ` (${unit?.toUpperCase()})` : '');
	},
	/**
	 * desc -to display only those field which have metric or actual value *
	 */
	checkCriticalParameter(target, actual, targetMax, actualMax) {
		let isTaget = false,
			isActual = false;
		if (target || targetMax) {
			isTaget = true;
		}
		if ((actual || actualMax) && target !== 'NA') {
			isActual = true;
		}
		return (isTaget && isActual) || isActual;
	},
	getRowValue(data, eventName) {
		let color;
		let icon;
		if (data.DataProperty === 'WasherCIResultIcon') {
			 color = data.value
				? data.value.indexOf('red') > -1 || data.value.indexOf('times') > -1
					? 'red'
					: 'green'
				: null;
			 icon = data.value
				? data.value.indexOf('red') > -1
					? data.value.replace('-red', '')
					: data.value.replace('-green', '')
				: null;
		}

		return (
			<div className="col-lg-4 col-md-6 col-sm-12 no-padding">
				<div className="row form-group">
					<div className="col-lg-6 col-sm-6 col-xs-6">
						<b> {data.HeaderLabel}</b>
						<span className="pull-right">: </span>
					</div>
					<div className="col-lg-6 col-sm-6 col-xs-6 no-padding">
						{data.DataProperty !== 'WasherCIResultIcon' ? (
							data.value
						) : data.value ? (
							<div className="columnIcon">
								<i
									style={{
										fontSize: 28,
										color: color
									}}
									className={'fa ' + icon}
								/>
							</div>
						) : (
							<div style={{ textAlign: 'center' }}>
								<button
									style={{ height: '2.4em' }}
									className="print-hide btn btn-success"
									onClick={eventName}
								>
									<i className="glyphicon glyphicon-plus"></i> {strings.Add}
								</button>
							</div>
						)}
					</div>
				</div>
			</div>
		);
	},
	getProcessMonitorCheck(data, cycleStatus) {
		if (!data) {
			return ''; // we will not send false/true in case we do not have data
		}
		let negativeResults = data.filter((element) => {
			return element.isVisible && element.CriticalParameterIcon.indexOf('fa-times') > -1;
		});
		return negativeResults.length === 0 && cycleStatus.toUpperCase() === consts.DefaultValue;
	},
	formatData(value, type, decimalMark) {
		let toReturn;
		const dateTimeFormat = this.getDateTimeFormat();
		const date = dayjs(value);
		switch (type) {
			case 'hrs_min':
			case 'min_sec':
			case 'date':
				toReturn = date.isValid() ? date.format(dateTimeFormat[type]) : value;
				break;
			case 'string':
				toReturn = value?.toUpperCase?.();
				break
			case 'bool':
				toReturn = value? 'True' : 'False';
				break;
			case 'text':
				toReturn = value;
				break;
			default:
				if (decimalMark && consts.DecimalMark.Comma.toUpperCase() === decimalMark.toUpperCase()) {
					toReturn = value.toString().replace('.', ',');
				} else {
					toReturn = value ? Number(value) : value;
				}
				break;
		}
		return toReturn === undefined ? '' : toReturn;
	},
	printRecipt(data, options = {}) {
		let printData = this.getPrintData(data, options);
		if (printData) {
			setTimeout(function () {
				renderElement(printData);
			}, 100);
		}
	},
	printTape(data, showModel) {
		let printData = this.getPrintData(data),
			printWindow = window.open();
		// using inline css - content is open in new window
		printWindow.document.write(
			'<html><head><title>Print</title></head><body><div style ="width:max-content;border:solid;border-width:thin;padding-left:2em;padding-right:2em ">' +
			printData +
			'</body></html>'
		);
		if (showModel) {
			printWindow.print();
			printWindow.close();
		}
	},
	hideModal(isViewXML, e) {
		e.preventDefault();
		const newState = {};
		if (isViewXML) {
			newState.modalIsXmlOpen = false;
		} else {
			newState.openPopUp = false;
		}
		this.setState(newState);
	},
	attachmentRenderer(value = {}) {
		return (
			<div style={{ textAlign: 'center' }}>
				<div>
					{!(value.AttachmentCount || 0) ? (
						<button className="btn btn-default attchmentBtn">
							<i className="fa fa-question-circle fa-2x img-responsive center-block default-color" />
						</button>
					) : (
						<button className="btn btn-default blank-attchmentBtn">N/A</button>
					)}
				</div>
			</div>
		);
	},
	getPrintData(data, options = {}) {
		const { isUltrasonic } = options;
		if (isUltrasonic) {
			return (
				Object.keys(data).length !== 0 &&
				data
					.replace('<PrinterLines />', '')
					.replace(/<PrinterLine>/g, '')
					.replace(/<PrinterLine \/\>/g, '')
					.replace(/<\/\PrinterLine>/g, '<br/>')
					.replace(/PrinterLines/g, 'p')
					.replace(/ /g, '&nbsp;')
			);
		} else {
			return (
				Object.keys(data).length !== 0 &&
				data
					.replace('<PrinterLines />', '')
					.replace(/<PrinterLine>/g, '')
					.replace(/<PrinterLine \/\>/g, '<br/>')
					.replace(/<\/\PrinterLine>/g, '<br/>')
					.replace(/PrinterLines/g, 'p')
					.replace(/ /g, '&nbsp;')
			);
		}
	},
	getBIResultIcon(value) {
		let { ModifiedByUserId, BIResult, IncubatorCycleDetailId, BITypeId } = value || {};
		if (ModifiedByUserId === null || ModifiedByUserId === undefined || ModifiedByUserId === consts.Default.value) {
			return consts.BIResultIcon.Pending;
		}
		if (BIResult === consts.BIResult.Error) {
			return consts.BIResultIcon.Error;
		}
		if (
			BIResult !== undefined &&
			(consts.isNodeServer ? IncubatorCycleDetailId : IncubatorCycleDetailId > consts.Default.value)
		) {
			if (BITypeId === consts.TestOrControl.Test) {
				return BIResult === consts.BIResult.Positive
					? consts.BIResultIcon.TestPositive
					: consts.BIResultIcon.TestNegative;
			}
			if (BITypeId === consts.TestOrControl.Control) {
				return BIResult === consts.BIResult.Negative
					? consts.BIResultIcon.ControlPositive
					: consts.BIResultIcon.ControlNegative;
			}
		}
		return '';
	},
	monitoringStatusRenderer(value) {
		let data = value.dependentValues || value || {};
		let { EquipmentTypeId, EquipmentFamilyId } = data;
		let isSteam = EquipmentTypeId === consts.EquipmentType.STEAMSTERILIZER ? true : false,
			isSteamEU = EquipmentFamilyId === consts.EquipmentFamilyType.STEAMEUSTERILIZER ? true : false,
			isAMSCOEU = EquipmentFamilyId === consts.EquipmentFamilyType.AMSCOEUSTERILIZER ? true : false,
			allowedCritical = this.printCriticalParameter(printProperties, { isSteam, isSteamEU, isAMSCOEU }),
			isAdvantage = EquipmentFamilyId === consts.EquipmentFamilyType.ADVANTAGE ? true : false,
			cycleName = (data.CycleName || '').replace(/\.| |-|_|/g, '').toUpperCase();
		let monitoringStatus = this.getProcessMonitoringStatus(data, allowedCritical, {
			isSteamEU,
			isAMSCOEU,
			isGrid: true
		});
		const nonSterisEquipment = [
			consts.EquipmentFamilyType.NONSTERISHP,
			consts.EquipmentFamilyType.NONSTERISSTEAM
		].includes(EquipmentFamilyId);
		if (isAdvantage) {
			return EquipmentTypeId === consts.EquipmentType.INCUBATOR || nonSterisEquipment ? null : (
				<div className="columnIcon">
					{(monitoringStatus || isAdvantage || consts.skipCriticalParamsArr.includes(cycleName)) &&
						(isAdvantage
							? data.CycleStatusId === consts.CycleStatus.AdvantageCyclePass ||
							data.CycleStatusId === consts.CycleStatus.OkWithErrors ||
							data.CycleStatusId === consts.CycleStatus.OkWithNoSCUMonitoring
							: data.CycleStatusId === consts.CycleStatus.Pass) ? (
						<i style={{ fontSize: 28, color: '#1ab394' }} className="fa fa-check" />
					) : null}
				</div>
			);
		}
		return EquipmentTypeId === consts.EquipmentType.INCUBATOR || nonSterisEquipment ? null : (
			<div className="columnIcon">
				{(monitoringStatus || isAdvantage || consts.skipCriticalParamsArr.includes(cycleName)) &&
					(isAdvantage
						? data.CycleStatusId === consts.CycleStatus.AdvantageCyclePass ||
						data.CycleStatusId === consts.CycleStatus.OkWithErrors ||
						data.CycleStatusId === consts.CycleStatus.OkWithNoSCUMonitoring
						: data.CycleStatusId === consts.CycleStatus.Pass) ? (
					<i style={{ fontSize: 28, color: '#1ab394' }} className="fa fa-check" />
				) : (
					<i style={{ fontSize: 28, color: 'red' }} className="fa fa-times" />
				)}
			</div>
		);
	},
	printCriticalParameter(printProperties, extraProps) {
		let allowedCritical = [],
			{ isSteam, isSteamEU, isAMSCOEU } = extraProps,
			printFilteredCritical = [];
		if (isSteam) {
			if (isAMSCOEU) {
				printFilteredCritical = printProperties.AMSCOEUSteam;
			} else if (isSteamEU) {
				printFilteredCritical = printProperties.EUSteam;
			} else {
				printFilteredCritical = printProperties.AAMISteam;
			}
		} else {
			printFilteredCritical = printProperties.VHPSteam;
		}
		printProperties.CriticalParameters.forEach(function (obj) {
			if (printFilteredCritical.includes(obj.Name)) {
				allowedCritical.push(obj);
			}
		});
		return allowedCritical;
	},
	stringFormat(format) {
		const args = Array.prototype.slice.call(arguments, 1);
		return format.replace(/{(\d+)}/g, function (match, number) {
			return typeof args[number] !== 'undefined' ? args[number] : match;
		});
	},
	validateEmail(mail) {
		if (!mail || /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
			return true;
		}
		return false;
	},
	getLoginData() {
		let data;
		if (this?.localData && this?.localData?.loginData) {
			data = this?.localData?.loginData;
		}
		return data;
	},
	getRoleValues() {
		let operatorId = null,
			departmentId = null,
			supervisorRoleId = null,
			superAdminId = null,
			administratorId,
			huluAdminId = null,
			superAdministratorId = null,
			viewerId = null,
			sterisSpecialistId = null,
			physicianAdminId = null;
		if (this.localData && this.localData.loginData) {
			const parseData = this.localData.loginData;
			const tags = parseData.tags;
			operatorId = tags.OperatorId;
			departmentId = tags.DepartmentId;
			supervisorRoleId = tags.SupervisorRoleId;
			superAdminId = tags.SuperAdminId;
			administratorId = tags.AdministratorRoleId;
			viewerId = tags.ViewerRoleId;
			huluAdminId = tags.HuluAdminRoleId;
			superAdministratorId = tags.SuperAdministratorRoleId;
			sterisSpecialistId = tags.SterisSpecialistIdRoleId;
			physicianAdminId = tags.PhysicianAdminRoleId;
		}
		return { operatorId, departmentId, supervisorRoleId, superAdminId, administratorId, viewerId, huluAdminId, superAdministratorId, sterisSpecialistId, physicianAdminId };
	},

	/**
	 * This is the main routine provided by the parseBarcode library. It takes a string,
	 * splices it from left to right into its elements and tries to parse it as an
	 * GS1 - element. If it succeeds, the result is returned as an object composed of
	 * an identifier and an array.It accepts
	 * @param   {String}   barcode is the contents of the barcode you'd like to get parsed
	 * @returns {Array}    an array with elements which are objects of type "ParsedElement"
	 */

	parseBarcode(barcode) {
		let i = 0, // counter
			fncChar = String.fromCharCode(29), // the ASCII "group separator"
			unicodeGroupSeparator = '\\u001d',
			es6UnicodeGroupSeparator = '\\x1d',
			barcodelength = barcode.length,
			answer = {}, // the object to return
			restOfBarcode = '', // the rest of the barcode, when first
			// elements are spliced away
			symbologyIdentifier = barcode.slice(0, 3),
			firstElement = {};

		//auxilliary functions

		/**
		 * "ParsedElement" is the
		 *
		 * @constructor for ParsedElements, the components of the array returned by parseBarcode
		 * @param {String} elementAI        the AI of the recognized element
		 * @param {String} elementDataTitle the title of the element, i.e. its short description
		 * @param {String} elementType      a one-letter string describing the type of the element.
		 *                                  allowed values are
		 *                                  "S" for strings,
		 *                                  "N" for numbers and
		 *                                  "D" for dates
		 */
		function ParsedElement(elementAI, elementDataTitle, elementType) {
			/* defines the object which represents a single element
			 */
			this.ai = elementAI; //application identifier
			this.dataTitle = elementDataTitle; //title
			switch (elementType) {
				case 'S':
					this.data = ''; // the contents
					break;
				case 'N':
					this.data = 0;
					break;
				case 'D':
					this.data = new Date();
					this.data.setHours(0, 0, 0, 0);
					break;
				default:
					this.data = '';
					break;
			}
			this.unit = ''; // some elements are accompaigned by an unit of
		}

		/**
		 *
		 * ================== BEGIN of identifyAI =======================
		 *
		 * does the main work:
		 *   what AI is in the beginning of the restOfBarcode?
		 *     If identified:
		 *       which function to call with
		 *       which parameters to parse the element?[Description]]
		 * @param   {String} codestring a string; the function tries to
		 *                   identify an AI in the beginning of this string
		 * @returns {Object} if it succeeds in identifying an AI the
		 *                   ParsedElement is returned, together with the
		 *                   still unparsed rest of codestring.
		 */
		function identifyAI(codestring, parsedCodeItems) {
			// find first identifier. AIs have a minimum length of 2
			// digits, some have 3, some even 4.
			let firstNumber = codestring.slice(0, 1),
				secondNumber = codestring.slice(1, 2),
				thirdNumber = '',
				fourthNumber = '',
				codestringToReturn = '',
				codestringLength = codestring.length,
				elementToReturn = '',
				nextAIType = null;

			/**
			 * ============ auxiliary functions for identifyAI =============
			 */
			/**
			 * some data items are followed by an FNC even in case of
			 * fixed length, so the codestringToReturn may have
			 * leading FNCs.
			 *
			 * This function eleminates these leading FNCs.
			 *
			 * @param   {String} stringToClean string which has to be cleaned
			 * @returns {String} the cleaned string
			 */
			function cleanCodestring(stringToClean) {
				//
				let firstChar = stringToClean.slice(0, 1);
				while (firstChar === fncChar) {
					stringToClean = stringToClean.slice(1, stringToClean.length);
					firstChar = stringToClean.slice(0, 1);
				}
				while (stringToClean.indexOf(unicodeGroupSeparator) > -1) {
					stringToClean = stringToClean.replace(unicodeGroupSeparator, '');
				}
				while (stringToClean.toLowerCase().indexOf(es6UnicodeGroupSeparator) > -1) {
					stringToClean = stringToClean.toLowerCase().replace(es6UnicodeGroupSeparator, '');
				}
				return stringToClean;
			}
			/**
			 * Used for calculating numbers which are given as string
			 * with a given number of fractional decimals.
			 *
			 * To avoid conversion errors binary <-> decimal I _don't_
			 * just divide by 10 numberOfFractionals times.
			 */
			function parseFloatingPoint(stringToParse, numberOfFractionals) {
				let auxString = '',
					offset = stringToParse.length - numberOfFractionals,
					auxFloat = 0.0;

				auxString = stringToParse.slice(0, offset) + '.' + stringToParse.slice(offset, stringToParse.length);
				try {
					auxFloat = parseFloat(auxString);
				} catch (e36) {
					throw new Error('36');	
				}
				return auxFloat;
			}
			/**
			 * ======== END of auxiliary function for identifyAI =======
			 */

			/**
			 *
			 * ======== BEGIN of parsing functions in identifyAI =======
			 *
			 * Some functions to parse the various GS1 formats. They
			 * create a new ParsedElement and set its properties.
			 *
			 * They all modify the variables "elementToReturn" and
			 * "codestringToReturn".
			 */

			/**
			 * dates in GS1-elements have the format "YYMMDD".
			 * This function generates a new ParsedElement and tries to fill a
			 * JS-date into the "data"-part.
			 * @param {String} ai    the AI to use for the ParsedElement
			 * @param {String} title the title to use for the ParsedElement
			 */
			function parseDate(ai, title) {
				elementToReturn = new ParsedElement(ai, title, 'D');
				let offSet = ai.length,
					dateYYMMDD = codestring.slice(offSet, offSet + 6),
					yearAsNumber = 0,
					monthAsNumber = 0,
					dayAsNumber = 0;

				try {
					yearAsNumber = parseInt(dateYYMMDD.slice(0, 2), 10);
				} catch (e33) {
					throw new Error('33');
				}

				try {
					monthAsNumber = parseInt(dateYYMMDD.slice(2, 4), 10) - 1;
				} catch (e34) {
					throw new Error('34');
				}

				try {
					dayAsNumber = parseInt(dateYYMMDD.slice(4, 6), 10);
				} catch (e35) {
					throw new Error('35');
				}
				// we are in the 21st century, but section 7.12 of the specification
				// states that years 51-99 should be considered to belong to the
				// 20th century:
				if (yearAsNumber > 50) {
					yearAsNumber = yearAsNumber + 1900;
				} else {
					yearAsNumber = yearAsNumber + 2000;
				}

				elementToReturn.data.setFullYear(yearAsNumber, monthAsNumber, dayAsNumber);
				codestringToReturn = codestring.slice(offSet + 6, codestringLength);
			}

			/**
			 * simple: the element has a fixed length AND is not followed by an FNC1.
			 * @param {String} ai     the AI to use
			 * @param {String} title  its title, i.e. its short description
			 * @param {Number} length the fixed length
			 */
			function parseFixedLength(ai, title, length) {
				elementToReturn = new ParsedElement(ai, title, 'S');
				let offSet = ai.length;
				elementToReturn.data = codestring.slice(offSet, length + offSet);
				codestringToReturn = codestring.slice(length + offSet, codestringLength);
			}

			/**
			 * tries to parse an element of variable length
			 * some fixed length AIs are terminated by FNC1, so this function
			 * is used even for fixed length items
			 * @param {String} ai    the AI to use
			 * @param {String} title its title, i.e. its short description
			 */
			function parseVariableLength(ai, title) {
				//
				elementToReturn = new ParsedElement(ai, title, 'S');
				let offSet = ai.length,
					posOfFNC = codestring.indexOf(fncChar);

				if (posOfFNC === -1) {
					//we've got the last element of the barcode
					elementToReturn.data = codestring.slice(offSet, codestringLength);
					codestringToReturn = '';
				} else {
					elementToReturn.data = codestring.slice(offSet, posOfFNC);
					codestringToReturn = codestring.slice(posOfFNC + 1, codestringLength);
				}
			}

			/**
			 * the place of the decimal fraction is given by the fourth number, that's
			 * the first after the identifier itself.
			 *
			 * All of theses elements have a length of 6 characters.
			 * @param {String} aiStem      the first digits of the AI, _not_ the fourth digit
			 * @param {Number} fourthNumber the 4th number indicating the count of valid fractionals
			 * @param {String} title        the title of the AI
			 * @param {String} unit         often these elements have an implicit unit of measurement
			 */
			function parseFixedLengthMeasure(aiStem, fourthNumber, title, unit) {
				//
				elementToReturn = new ParsedElement(aiStem + fourthNumber, title, 'N');
				let offSet = aiStem.length + 1,
					numberOfDecimals = parseInt(fourthNumber, 10),
					numberPart = codestring.slice(offSet, offSet + 6);

				elementToReturn.data = parseFloatingPoint(numberPart, numberOfDecimals);

				elementToReturn.unit = unit;
				codestringToReturn = codestring.slice(offSet + 6, codestringLength);
			}

			/**
			 * parses data elements of variable length, which additionally have
			 *
			 * - an indicator for the number of valid decimals
			 * - an implicit unit of measurement
			 *
			 * These data elements contain e.g. a weight or length.
			 *
			 */
			function parseVariableLengthMeasure(aiStem, fourthNumber, title, unit) {
				// the place of the decimal fraction is given by the fourth number, that's
				// the first after the identifier itself.
				elementToReturn = new ParsedElement(aiStem + fourthNumber, title, 'N');
				let offSet = aiStem.length + 1,
					posOfFNC = codestring.indexOf(fncChar),
					numberOfDecimals = parseInt(fourthNumber, 10),
					numberPart = '';

				if (posOfFNC === -1) {
					numberPart = codestring.slice(offSet, codestringLength);
					codestringToReturn = '';
				} else {
					numberPart = codestring.slice(offSet, posOfFNC);
					codestringToReturn = codestring.slice(posOfFNC + 1, codestringLength);
				}
				// adjust decimals according to fourthNumber:

				elementToReturn.data = parseFloatingPoint(numberPart, numberOfDecimals);
				elementToReturn.unit = unit;
			}

			/**
			 * parses data elements of variable length, which additionally have
			 *
			 * - an indicator for the number of valid decimals
			 * - an explicit unit of measurement
			 *
			 * These data element contain amounts to pay or prices.
			 *
			 */
			function parseVariableLengthWithISONumbers(aiStem, fourthNumber, title) {
				// an element of variable length, representing a number, followed by
				// some ISO-code.
				elementToReturn = new ParsedElement(aiStem + fourthNumber, title, 'N');
				let offSet = aiStem.length + 1,
					posOfFNC = codestring.indexOf(fncChar),
					numberOfDecimals = parseInt(fourthNumber, 10),
					isoPlusNumbers = '',
					numberPart = '';

				if (posOfFNC === -1) {
					isoPlusNumbers = codestring.slice(offSet, codestringLength);
					codestringToReturn = '';
				} else {
					isoPlusNumbers = codestring.slice(offSet, posOfFNC);
					codestringToReturn = codestring.slice(posOfFNC + 1, codestringLength);
				}
				// cut off ISO-Code
				numberPart = isoPlusNumbers.slice(3, isoPlusNumbers.length);
				elementToReturn.data = parseFloatingPoint(numberPart, numberOfDecimals);

				elementToReturn.unit = isoPlusNumbers.slice(0, 3);
			}
			/**
			 * parses data elements of variable length, which additionally have
			 *
			 * - an explicit unit of measurement or reference
			 *
			 * These data element contain countries, authorities within countries.
			 *
			 */
			function parseVariableLengthWithISOChars(aiStem, title) {
				// an element of variable length, representing a sequence of chars, followed by
				// some ISO-code.
				elementToReturn = new ParsedElement(aiStem, title, 'S');
				let offSet = aiStem.length,
					posOfFNC = codestring.indexOf(fncChar),
					isoPlusNumbers = '';

				if (posOfFNC === -1) {
					isoPlusNumbers = codestring.slice(offSet, codestringLength);
					codestringToReturn = '';
				} else {
					isoPlusNumbers = codestring.slice(offSet, posOfFNC);
					codestringToReturn = codestring.slice(posOfFNC + 1, codestringLength);
				}
				// cut off ISO-Code
				elementToReturn.data = isoPlusNumbers.slice(3, isoPlusNumbers.length);
				elementToReturn.unit = isoPlusNumbers.slice(0, 3);
			}

			function checkContainLotAndExp(aiLength) {
				let toReturn = null,
					aIType = codestring.substr(2).slice(aiLength, aiLength + 2);
				if (aIType && (aIType === '91' || aIType === '10')) {
					nextAIType = {
						nextAIValue: codestring.slice(aiLength === 8 ? 10 : 8, codestring.length),
						currentAILength: aiLength
					};
				}
				return toReturn;
			}

			/**
			 *
			 * ======== END of parsing functions in identifyAI =======
			 *
			 */
			/**
			 *
			 * ======= BEGIN of the big switch =======================
			 *
			 * and now a very big "switch", which tries to find a valid
			 * AI within the first digits of the codestring.
			 *
			 * See the documentation for an explanation why it is made
			 * this way (and not by some configuration file).
			 */

			switch (firstNumber) {
				case '0':
					switch (secondNumber) {
						case '0':
							// SSCC (Serial Shipping Container Code)
							parseFixedLength('00', 'SSCC', 18);
							break;
						case '1':
							// Global Trade Item Number (GTIN)
							parseFixedLength('01', 'GTIN', 14);
							break;
						case '2':
							// GTIN of Contained Trade Items
							parseFixedLength('02', 'CONTENT', 14);
							break;
						default:
							throw new Error('01');
					}
					break;
				case '1':
					switch (secondNumber) {
						case '0':
							let codestringCopy = codestring,
								strFrom = 4,
								endAt = 10;
							if (codestringCopy.length === 10) {
								parseFixedLength('10', 'BATCH/LOT', 8);
							} else {
								checkContainLotAndExp(8);
								if (!nextAIType) {
									checkContainLotAndExp(6);
									strFrom = 2;
									endAt = 8;
								}
								// Batch or Lot Number
								if (nextAIType) {
									parseFixedLength('10', 'BATCH/LOT', nextAIType.currentAILength);
									codestringToReturn =
										'17' + codestringCopy.slice(strFrom, endAt) + nextAIType.nextAIValue;
								} else {
									parseFixedLength('10', 'BATCH/LOT', 6);
								}
							}
							break;
						case '1':
							// Production Date (YYMMDD)
							parseDate('11', 'PROD DATE');
							break;
						case '2':
							// Due Date (YYMMDD)
							parseDate('12', 'DUE DATE');
							break;
						case '3':
							// Packaging Date (YYMMDD)
							parseDate('13', 'PACK DATE');
							break;
						// AI "14" isn't defined
						case '5':
							// Best Before Date (YYMMDD)
							parseDate('15', 'BEST BEFORE or BEST BY');
							break;
						case '6':
							// Sell By Date (YYMMDD)
							parseDate('16', 'SELL BY');
							break;
						case '7':
							// Expiration Date (YYMMDD)
							let copyString = codestring,
								str = 4,
								end = 10;
							if (codestring.length === 20) {
								checkContainLotAndExp(8);
								// Batch or Lot Number
								parseFixedLength('10', 'BATCH/LOT', nextAIType.currentAILength);
								codestringToReturn = '17' + copyString.slice(str, end) + nextAIType.nextAIValue;
							} else {
								parseDate('17', 'USE BY OR EXPIRY');
							}
							break;
						case '8':
							// Serial Number
							parseVariableLength('18', 'SerialNumber');
							break;
						default:
							throw new Error('02');
					}
					break;
				case '2':
					switch (secondNumber) {
						case '0':
							// Variant Number
							parseFixedLength('20', 'VARIANT', 2);
							break;
						case '1':
							// Serial Number
							parseVariableLength('21', 'SERIAL');
							break;
						// AI 22, 23 are not defined
						case '4':
							// from now, the third number matters:
							thirdNumber = codestring.slice(2, 3);
							switch (thirdNumber) {
								case '0':
									// Additional Item Identification
									parseVariableLength('240', 'ADDITIONAL ID');
									break;
								case '1':
									// Customer Part Number
									parseVariableLength('241', 'CUST. PART NO.');
									break;
								case '2':
									// Made-to-Order Variation Number
									parseVariableLength('242', 'MTO VARIANT');
									break;
								case '3':
									// Packaging Component Number
									parseVariableLength('243', 'PCN');
									break;
								default:
									throw new Error('03');
							}
							break;
						case '5':
							// from now, the third number matters:
							thirdNumber = codestring.slice(2, 3);
							switch (thirdNumber) {
								case '0':
									// Secondary Serial Number
									parseVariableLength('250', 'SECONDARY SERIAL');
									break;
								case '1':
									// Reference to Source Entity
									parseVariableLength('251', 'REF. TO SOURCE');
									break;
								// AI "252" isn't defined
								case '3':
									// Global Document Type Identifier (GDTI)
									parseVariableLength('253', 'GDTI');
									break;
								case '4':
									// GLN Extension Component
									parseVariableLength('254', 'GLN EXTENSION COMPONENT');
									break;
								case '5':
									// Global Coupon Number (GCN)
									parseVariableLength('255', 'GCN');
									break;
								default:
									throw new Error('04');
							}
							break;
						// AI "26" to "29" aren't defined
						default:
							throw new Error('05');
					}
					break;
				case '3':
					switch (secondNumber) {
						case '0':
							// Count of Items (Variable Measure Trade Item)
							parseVariableLength('30', 'VAR. COUNT');
							break;
						case '1':
							// third and fourth numbers matter:
							thirdNumber = codestring.slice(2, 3);
							fourthNumber = codestring.slice(3, 4);

							switch (thirdNumber) {
								case '0':
									// Net weight, kilograms (Variable Measure Trade Item)
									parseFixedLengthMeasure('310', fourthNumber, 'NET WEIGHT (kg)', 'KGM');
									break;
								case '1':
									// Length or first dimension, metres (Variable Measure Trade Item)
									parseFixedLengthMeasure('311', fourthNumber, 'LENGTH (m)', 'MTR');
									break;
								case '2':
									// Width, diameter, or second dimension, metres (Variable Measure Trade Item)
									parseFixedLengthMeasure('312', fourthNumber, 'WIDTH (m)', 'MTR');
									break;
								case '3':
									// Depth, thickness, height, or third dimension, metres (Variable Measure Trade Item)
									parseFixedLengthMeasure('313', fourthNumber, 'HEIGHT (m)', 'MTR');
									break;
								case '4':
									// Area, square metres (Variable Measure Trade Item)
									parseFixedLengthMeasure('314', fourthNumber, 'AREA (m2)', 'MTK');
									break;
								case '5':
									// Net volume, litres (Variable Measure Trade Item)
									parseFixedLengthMeasure('315', fourthNumber, 'NET VOLUME (l)', 'LTR');
									break;
								case '6':
									// Net volume, cubic metres (Variable Measure Trade Item)
									parseFixedLengthMeasure('316', fourthNumber, 'NET VOLUME (m3)', 'MTQ');
									break;
								default:
									throw  new Error ('06');
							}
							break;
						case '2':
							// third and fourth numbers matter:
							thirdNumber = codestring.slice(2, 3);
							fourthNumber = codestring.slice(3, 4);

							switch (thirdNumber) {
								case '0':
									// Net weight, pounds (Variable Measure Trade Item)
									parseFixedLengthMeasure('320', fourthNumber, 'NET WEIGHT (lb)', 'LBR');
									break;
								case '1':
									// Length or first dimension, inches (Variable Measure Trade Item)
									parseFixedLengthMeasure('321', fourthNumber, 'LENGTH (i)', 'INH');
									break;
								case '2':
									// Length or first dimension, feet (Variable Measure Trade Item)
									parseFixedLengthMeasure('322', fourthNumber, 'LENGTH (f)', 'FOT');
									break;
								case '3':
									// Length or first dimension, yards (Variable Measure Trade Item)
									parseFixedLengthMeasure('323', fourthNumber, 'LENGTH (y)', 'YRD');
									break;
								case '4':
									// Width, diameter, or second dimension, inches (Variable Measure Trade Item)
									parseFixedLengthMeasure('324', fourthNumber, 'WIDTH (i)', 'INH');
									break;
								case '5':
									// Width, diameter, or second dimension, feet (Variable Measure Trade Item)
									parseFixedLengthMeasure('325', fourthNumber, 'WIDTH (f)', 'FOT');
									break;
								case '6':
									// Width, diameter, or second dimension, yards (Variable Measure Trade Item
									parseFixedLengthMeasure('326', fourthNumber, 'WIDTH (y)', 'YRD');
									break;
								case '7':
									// Depth, thickness, height, or third dimension, inches (Variable Measure Trade Item)
									parseFixedLengthMeasure('327', fourthNumber, 'HEIGHT (i)', 'INH');
									break;
								case '8':
									// Depth, thickness, height, or third dimension, feet (Variable Measure Trade Item)
									parseFixedLengthMeasure('328', fourthNumber, 'HEIGHT (f)', 'FOT');
									break;
								case '9':
									// Depth, thickness, height, or third dimension, yards (Variable Measure Trade Item)
									parseFixedLengthMeasure('329', fourthNumber, 'HEIGHT (y)', 'YRD');
									break;
								default:
									throw new Error('07');
							}
							break;
						case '3':
							// third and fourth numbers matter:
							thirdNumber = codestring.slice(2, 3);
							fourthNumber = codestring.slice(3, 4);

							switch (thirdNumber) {
								case '0':
									// Logistic weight, kilograms
									parseFixedLengthMeasure('330', fourthNumber, 'GROSS WEIGHT (kg)', 'KGM');
									break;
								case '1':
									// Length or first dimension, metres
									parseFixedLengthMeasure('331', fourthNumber, 'LENGTH (m), log', 'MTR');
									break;
								case '2':
									// Width, diameter, or second dimension, metres
									parseFixedLengthMeasure('332', fourthNumber, 'WIDTH (m), log', 'MTR');
									break;
								case '3':
									// Depth, thickness, height, or third dimension, metres
									parseFixedLengthMeasure('333', fourthNumber, 'HEIGHT (m), log', 'MTR');
									break;
								case '4':
									// Area, square metres
									parseFixedLengthMeasure('334', fourthNumber, 'AREA (m2), log', 'MTK');
									break;
								case '5':
									// Logistic volume, litres
									parseFixedLengthMeasure('335', fourthNumber, 'VOLUME (l), log', 'LTR');
									break;
								case '6':
									// Logistic volume, cubic metres
									parseFixedLengthMeasure('336', fourthNumber, 'VOLUME (m3), log', 'MTQ');
									break;
								case '7':
									// Kilograms per square metre, yes, the ISO code for this _is_ "28".
									parseFixedLengthMeasure('337', fourthNumber, 'KG PER m²', '28');
									break;
								default:
									throw new Error('08');
							}
							break;
						case '4':
							// third and fourth numbers matter:
							thirdNumber = codestring.slice(2, 3);
							fourthNumber = codestring.slice(3, 4);

							switch (thirdNumber) {
								case '0':
									// Logistic weight, pounds
									parseFixedLengthMeasure('340', fourthNumber, 'GROSS WEIGHT (lb)', 'LBR');
									break;
								case '1':
									// Length or first dimension, inches
									parseFixedLengthMeasure('341', fourthNumber, 'LENGTH (i), log', 'INH');
									break;
								case '2':
									// Length or first dimension, feet
									parseFixedLengthMeasure('342', fourthNumber, 'LENGTH (f), log', 'FOT');
									break;
								case '3':
									// Length or first dimension, yards
									parseFixedLengthMeasure('343', fourthNumber, 'LENGTH (y), log', 'YRD');
									break;
								case '4':
									// Width, diameter, or second dimension, inches
									parseFixedLengthMeasure('344', fourthNumber, 'WIDTH (i), log', 'INH');
									break;
								case '5':
									// Width, diameter, or second dimension, feet
									parseFixedLengthMeasure('345', fourthNumber, 'WIDTH (f), log', 'FOT');
									break;
								case '6':
									// Width, diameter, or second dimension, yard
									parseFixedLengthMeasure('346', fourthNumber, 'WIDTH (y), log', 'YRD');
									break;
								case '7':
									// Depth, thickness, height, or third dimension, inches
									parseFixedLengthMeasure('347', fourthNumber, 'HEIGHT (i), log', 'INH');
									break;
								case '8':
									// Depth, thickness, height, or third dimension, feet
									parseFixedLengthMeasure('348', fourthNumber, 'HEIGHT (f), log', 'FOT');
									break;
								case '9':
									// Depth, thickness, height, or third dimension, yards
									parseFixedLengthMeasure('349', fourthNumber, 'HEIGHT (y), log', 'YRD');
									break;
								default:
									throw new Error('09');
							}
							break;
						case '5':
							// third and fourth numbers matter:
							thirdNumber = codestring.slice(2, 3);
							fourthNumber = codestring.slice(3, 4);

							switch (thirdNumber) {
								case '0':
									// Area, square inches (Variable Measure Trade Item)
									parseFixedLengthMeasure('350', fourthNumber, 'AREA (i2)', 'INK');
									break;
								case '1':
									// Area, square feet (Variable Measure Trade Item)
									parseFixedLengthMeasure('351', fourthNumber, 'AREA (f2)', 'FTK');
									break;
								case '2':
									// Area, square yards (Variable Measure Trade Item)
									parseFixedLengthMeasure('352', fourthNumber, 'AREA (y2)', 'YDK');
									break;
								case '3':
									// Area, square inches
									parseFixedLengthMeasure('353', fourthNumber, 'AREA (i2), log', 'INK');
									break;
								case '4':
									// Area, square feet
									parseFixedLengthMeasure('354', fourthNumber, 'AREA (f2), log', 'FTK');
									break;
								case '5':
									// Area, square yards
									parseFixedLengthMeasure('355', fourthNumber, 'AREA (y2), log', 'YDK');
									break;
								case '6':
									// Net weight, troy ounces (Variable Measure Trade Item)
									parseFixedLengthMeasure('356', fourthNumber, 'NET WEIGHT (t)', 'APZ');
									break;
								case '7':
									// Net weight (or volume), ounces (Variable Measure Trade Item)
									parseFixedLengthMeasure('357', fourthNumber, 'NET VOLUME (oz)', 'ONZ');
									break;
								default:
									throw new Error('10');
							}
							break;
						case '6':
							// third and fourth numbers matter:
							thirdNumber = codestring.slice(2, 3);
							fourthNumber = codestring.slice(3, 4);

							switch (thirdNumber) {
								case '0':
									// Net volume, quarts (Variable Measure Trade Item)
									parseFixedLengthMeasure('360', fourthNumber, 'NET VOLUME (q)', 'QT');
									break;
								case '1':
									// Net volume, gallons U.S. (Variable Measure Trade Item)
									parseFixedLengthMeasure('361', fourthNumber, 'NET VOLUME (g)', 'GLL');
									break;
								case '2':
									// Logistic volume, quarts
									parseFixedLengthMeasure('362', fourthNumber, 'VOLUME (q), log', 'QT');
									break;
								case '3':
									// Logistic volume, gallons U.S.
									parseFixedLengthMeasure('363', fourthNumber, 'VOLUME (g), log', 'GLL');
									break;
								case '4':
									// Net volume, cubic inches (Variable Measure Trade Item)
									parseFixedLengthMeasure('364', fourthNumber, 'VOLUME (i3)', 'INQ');
									break;
								case '5':
									// Net volume, cubic feet (Variable Measure Trade Item)
									parseFixedLengthMeasure('365', fourthNumber, 'VOLUME (f3)', 'FTQ');
									break;
								case '6':
									// Net volume, cubic yards (Variable Measure Trade Item)
									parseFixedLengthMeasure('366', fourthNumber, 'VOLUME (y3)', 'YDQ');
									break;
								case '7':
									// Logistic volume, cubic inches
									parseFixedLengthMeasure('367', fourthNumber, 'VOLUME (i3), log', 'INQ');
									break;
								case '8':
									// Logistic volume, cubic feet
									parseFixedLengthMeasure('368', fourthNumber, 'VOLUME (f3), log', 'FTQ');
									break;
								case '9':
									// Logistic volume, cubic yards
									parseFixedLengthMeasure('369', fourthNumber, 'VOLUME (y3), log', 'YDQ');
									break;
								default:
									throw new Error('11');
							}
							break;
						case '7':
							// Count of Trade Items
							parseVariableLength('37', 'COUNT');
							break;
						// AI "38" isn't defined
						case '9':
							// third and fourth numbers matter:
							thirdNumber = codestring.slice(2, 3);
							fourthNumber = codestring.slice(3, 4);

							switch (thirdNumber) {
								case '0':
									// Applicable Amount Payable, local currency
									parseVariableLengthMeasure('390', fourthNumber, 'AMOUNT', '');
									break;
								case '1':
									// Applicable Amount Payable with ISO Currency Code
									parseVariableLengthWithISONumbers('391', fourthNumber, 'AMOUNT');
									break;
								case '2':
									// Applicable Amount Payable, single monetary area (Variable Measure Trade Item)
									parseVariableLengthMeasure('392', fourthNumber, 'PRICE', '');
									break;
								case '3':
									// Applicable Amount Payable with ISO Currency Code (Variable Measure Trade Item)
									parseVariableLengthWithISONumbers('393', fourthNumber, 'PRICE');
									break;
								default:
									throw new Error('12');
							}
							break;
						default:
							throw new Error('13');
					}
					break;
				case '4':
					switch (secondNumber) {
						case '0':
							// third number matters:
							thirdNumber = codestring.slice(2, 3);
							switch (thirdNumber) {
								case '0':
									// Customer's Purchase Order Number
									parseVariableLength('400', 'ORDER NUMBER');
									break;
								case '1':
									// Global Identification Number for Consignment (GINC)
									parseVariableLength('401', 'GINC');
									break;
								case '2':
									// Global Shipment Identification Number (GSIN)
									parseVariableLength('402', 'GSIN'); // should be 17 digits long
									break;
								case '3':
									// Routing Code
									parseVariableLength('403', 'ROUTE');
									break;
								default:
									throw new Error('14');
							}
							break;
						case '1':
							//third number matters:
							thirdNumber = codestring.slice(2, 3);
							switch (thirdNumber) {
								case '0':
									// Ship to - Deliver to Global Location Number
									parseFixedLength('410', 'SHIP TO LOC', 13);
									break;
								case '1':
									// Bill to - Invoice to Global Location Number
									parseFixedLength('411', 'BILL TO', 13);
									break;
								case '2':
									// Purchased from Global Location Number
									parseFixedLength('412', 'PURCHASE FROM', 13);
									break;
								case '3':
									// Ship for - Deliver for - Forward to Global Location Number
									parseFixedLength('413', 'SHIP FOR LOC', 13);
									break;
								default:
									throw new Error('15');
							}
							break;
						case '2':
							//third number matters:
							thirdNumber = codestring.slice(2, 3);
							switch (thirdNumber) {
								case '0':
									// Ship to - Deliver to Postal Code Within a Single Postal Authority
									parseVariableLength('420', 'SHIP TO POST');
									break;
								case '1':
									// Ship to - Deliver to Postal Code with ISO Country Code
									parseVariableLengthWithISOChars('421', 'SHIP TO POST');
									break;
								case '2':
									// Country of Origin of a Trade Item
									parseFixedLength('422', 'ORIGIN', 3);
									break;
								case '3':
									// Country of Initial Processing
									// Up to 5 3-digit ISO-countrycodes
									parseVariableLength('423', 'COUNTRY - INITIAL PROCESS.');
									break;
								case '4':
									// Country of Processing
									parseFixedLength('424', 'COUNTRY - PROCESS.', 3);
									break;
								case '5':
									// Country of Disassembly
									parseFixedLength('425', 'COUNTRY - DISASSEMBLY', 3);
									break;
								case '6':
									// Country Covering full Process Chain
									parseFixedLength('426', 'COUNTRY – FULL PROCESS', 3);
									break;
								case '7':
									// Country Subdivision of Origin
									parseVariableLength('427', 'ORIGIN SUBDIVISION');
									break;
								default:
									throw new Error('16');
							}
							break;
						default:
							throw new Error('17');
					}
					break;
				// first digits 5 and 6 are not used
				case '7':
					switch (secondNumber) {
						case '0':
							//third and fourth number matter:
							thirdNumber = codestring.slice(2, 3);
							fourthNumber = codestring.slice(3, 4);

							switch (thirdNumber) {
								case '0':
									switch (fourthNumber) {
										case '1':
											// NATO Stock Number (NSN)
											parseVariableLength('7001', 'NSN'); //should be 13 digits long
											break;
										case '2':
											// UN/ECE Meat Carcasses and Cuts Classification
											parseVariableLength('7002', 'MEAT CUT');
											break;
										case '3':
											// Expiration Date and Time
											parseVariableLength('7003', 'EXPIRY TIME'); //should be 10 digits long
											break;
										case '4':
											// Active Potency
											parseVariableLength('7004', 'ACTIVE POTENCY');
											break;
										default:
											throw new Error('18');
									}
									break;
								// 1 and 2 are not used
								case '3':
									// Approval Number of Processor with ISO Country Code

									// Title and stem for parsing are build from 4th number:

									parseVariableLengthWithISOChars('703' + fourthNumber, 'PROCESSOR # ' + fourthNumber);
									break;
								default:
									throw  new Error('19');
							}
							break;
						case '1':
							thirdNumber = codestring.slice(2, 3);
							switch (thirdNumber) {
								case '0':
									// National Healthcare Reimbursement Number (NHRN) – Germany PZN
									parseVariableLength('710', 'NHRN PZN');
									break;
								case '1':
									// National Healthcare Reimbursement Number (NHRN) – France CIP
									parseVariableLength('711', 'NHRN CIP');
									break;
								case '2':
									// National Healthcare Reimbursement Number (NHRN) – Spain CN
									parseVariableLength('712', 'NHRN CN');
									break;
								case '3':
									// National Healthcare Reimbursement Number (NHRN) – Brasil DRN
									parseVariableLength('713', 'NHRN DRN');
									break;
								default:
									throw new Error('20');
							}
							break;
						default:
							throw new Error('21');
					}
					break;
				case '8':
					switch (secondNumber) {
						case '0':
							thirdNumber = codestring.slice(2, 3);
							fourthNumber = codestring.slice(3, 4);

							switch (thirdNumber) {
								case '0':
									switch (fourthNumber) {
										case '1':
											// Roll Products (Width, Length, Core Diameter, Direction, Splices)
											parseVariableLength('8001', 'DIMENSIONS'); // should be 14 digits long
											break;
										case '2':
											// Cellular Mobile Telephone Identifier
											parseVariableLength('8002', 'CMT No');
											break;
										case '3':
											// Global Returnable Asset Identifier (GRAI)
											parseVariableLength('8003', 'GRAI'); // should contain at least 14 digits
											break;
										case '4':
											// Global Individual Asset Identifier (GIAI)
											parseVariableLength('8004', 'GIAI');
											break;
										case '5':
											// Price Per Unit of Measure
											parseVariableLength('8005', 'PRICE PER UNIT'); // should be 6 digits long
											break;
										case '6':
											// Identification of the Components of a Trade Item
											parseVariableLength('8006', 'GCTIN'); // should be exactly 18 digits long
											break;
										case '7':
											// International Bank Account Number (IBAN)
											parseVariableLength('8007', 'IBAN');
											break;
										case '8':
											// Date and Time of Production
											parseVariableLength('8008', 'PROD TIME'); // should be exactly 12 digits long
											break;
										default:
											throw new Error('22');
									}
									break;
								case '1':
									switch (fourthNumber) {
										case '0':
											// Component / Part Identifier (CPID)
											parseVariableLength('8010', 'CPID');
											break;
										case '1':
											// Component / Part Identifier Serial Number (CPID SERIAL)
											parseVariableLength('8011', 'CPID SERIAL');
											break;
										case '7':
											// Global Service Relation Number to identify the relationship between an organisation offering services and the provider of services
											parseVariableLength('8017', 'GSRN - PROVIDER'); // should be 18 digits long
											break;
										case '8':
											// Global Service Relation Number to identify the relationship between an organisation offering services and the recipient of services
											parseVariableLength('8018', 'GSRN - RECIPIENT'); // should be 18 digits long
											break;
										case '9':
											// Service Relation Instance Number (SRIN)
											parseVariableLength('8019', 'SRIN');
											break;
										default:
											throw new Error('23');
									}
									break;
								case '2':
									switch (fourthNumber) {
										case '0':
											// Payment Slip Reference Number
											parseVariableLength('8020', 'REF No');
											break;
										default:
											throw new Error('24');
									}
									break;
								default:
									throw new Error('25');
							}
							break;
						case '1':
							thirdNumber = codestring.slice(2, 3);
							fourthNumber = codestring.slice(3, 4);
							switch (thirdNumber) {
								case '0':
									switch (fourthNumber) {
										case '0':
											// GS1-128 Coupon Extended Code
											parseVariableLength('8100', '-'); //should be 6 digits long
											break;
										case '1':
											// GS1-128 Coupon Extended Code
											parseVariableLength('8101', '-'); //should be 10 digits long
											break;
										case '2':
											// GS1-128 Coupon Extended Code
											parseVariableLength('8102', '-'); //should be 2 digits long
											break;
										default:
											throw new Error('26');
									}
									break;
								case '1':
									switch (fourthNumber) {
										case '0':
											// Coupon Code Identification for Use in North America
											parseVariableLength('8110', '-');
											break;
										default:
											throw new Error('27');
									}
									break;
								default:
									throw new Error('28');
							}
							break;
						case '2':
							thirdNumber = codestring.slice(2, 3);
							switch (thirdNumber) {
								case '0':
									// Extended Packaging URL
									parseVariableLength('8200', 'PRODUCT URL');
									break;
								default:
									throw new Error('29');
							}
							break;
						default:
							throw new Error('30');
					}
					break;
				case '9':
					switch (secondNumber) {
						case '0':
							// Information Mutually Agreed Between Trading Partners
							parseVariableLength('90', 'INTERNAL');
							break;
						case '1':
							// Company Internal Information
							parseVariableLength('91', 'SerialNo');
							break;
						case '2':
							// Company Internal Information
							parseVariableLength('92', 'INTERNAL');
							break;
						case '3':
							// Company Internal Information
							parseVariableLength('93', 'INTERNAL');
							break;
						case '4':
							// Company Internal Information
							parseVariableLength('94', 'INTERNAL');
							break;
						case '5':
							// Company Internal Information
							parseVariableLength('95', 'INTERNAL');
							break;
						case '6':
							// Company Internal Information
							parseVariableLength('96', 'INTERNAL');
							break;
						case '7':
							// Company Internal Information
							parseVariableLength('97', 'INTERNAL');
							break;
						case '8':
							// Company Internal Information
							parseVariableLength('98', 'INTERNAL');
							break;
						case '9':
							// Company Internal Information
							parseVariableLength('99', 'INTERNAL');
							break;
						default:
							throw new Error('31');
					}
					break;
				default:
					throw new Error('32');
			}
			/**
			 *
			 * ======= END of the big switch =======================
			 *
			 * now identifyAI has just to return the new
			 * ParsedElement (create by one of the parsing
			 * functions) and the (cleaned) rest of codestring.
			 */

			return {
				element: elementToReturn,
				codestring: cleanCodestring(codestringToReturn)
			};
		}

		/**
		 *
		 * =========== END of identifyAI =======================
		 *
		 */

		/**
		 * =========== BEGIN of main routine ===================
		 */

		/**
		 *
		 * ==== First step: ====
		 *
		 * IF there is any symbology identifier
		 *   chop it off;
		 *   put as "codeName" into the answer;
		 *   fill restOfBarcode with the rest
		 *   after the symbology identifier;
		 * ELSE
		 *   leave "codeName" empty;
		 *   put the whole barcode into restOfBarcode;
		 */

		switch (symbologyIdentifier) {
			case ']C1':
				answer.codeName = 'GS1-128';
				restOfBarcode = barcode.slice(3, barcodelength);
				break;
			case ']e0':
				answer.codeName = 'GS1 DataBar';
				restOfBarcode = barcode.slice(3, barcodelength);
				break;
			case ']e1':
				answer.codeName = 'GS1 Composite';
				restOfBarcode = barcode.slice(3, barcodelength);
				break;
			case ']e2':
				answer.codeName = 'GS1 Composite';
				restOfBarcode = barcode.slice(3, barcodelength);
				break;
			case ']d2':
				answer.codeName = 'GS1 DataMatrix';
				restOfBarcode = barcode.slice(3, barcodelength);
				break;
			case ']Q3':
				answer.codeName = 'GS1 QR Code';
				restOfBarcode = barcode.slice(3, barcodelength);
				break;
			default:
				answer.codeName = '';
				restOfBarcode = barcode;
				break;
		}

		/**
		 * we have chopped off any symbology identifier. Now we can
		 * try to parse the rest. It should give us an array of
		 * ParsedElements.
		 */

		/**
		 * ===== Second step: ====
		 *
		 * Parse "barcode" data element by data element using
		 * identifyAI.
		 *
		 */

		answer.parsedCodeItems = [];

		/**
		 * The follwoing part calls "identifyAI" in a loop, until
		 * the whole barcode is parsed (or an error occurs).
		 *
		 * It uses the following strategy:
		 *
		 *   try to parse the part after the symbology identifier:
		 *   - identify the first AI;
		 *   - make a parsed element from the part after the AI;
		 *   - append the parsed element to answer;
		 *   - chop off the parsed part;
		 *  do so while there is left something to parse;
		 */

		while (restOfBarcode.length > 0) {
			try {
				firstElement = identifyAI(restOfBarcode, answer.parsedCodeItems);
				restOfBarcode = firstElement.codestring;
				answer.parsedCodeItems.push(firstElement.element);
			} catch (e) {
				switch (e.message) {
					case '01':
						throw new Error("invalid AI after '0'");
					case '02':
						throw new Error("invalid AI after '1'");
					case '03':
						throw new Error("invalid AI after '24'");
					case '04':
						throw new Error("invalid AI after '25'");
					case '05':
						throw new Error("invalid AI after '2'");
					case '06':
						throw new Error("invalid AI after '31'");
					case '07':
						throw new Error("invalid AI after '32'");
					case '08':
						throw new Error("invalid AI after '33'");
					case '09':
						throw new Error("invalid AI after '34'");
					case '10':
						throw new Error("invalid AI after '35'");
					case '11':
						throw new Error("invalid AI after '36'");
					case '12':
						throw new Error("invalid AI after '39'");
					case '13':
						throw new Error("invalid AI after '3'");
					case '14':
						throw new Error("invalid AI after '40'");
					case '15':
						throw new Error("invalid AI after '41'");
					case '16':
						throw new Error("invalid AI after '42'");
					case '17':
						throw new Error("invalid AI after '4'");
					case '18':
						throw new Error("invalid AI after '700'");
					case '19':
						throw new Error("invalid AI after '70'");
					case '20':
						throw new Error("invalid AI after '71'");
					case '21':
						throw new Error("invalid AI after '7'");
					case '22':
						throw new Error("invalid AI after '800'");
					case '23':
						throw new Error("invalid AI after '801'");
					case '24':
						throw new Error("invalid AI after '802'");
					case '25':
						throw new Error("invalid AI after '80'");
					case '26':
						throw new Error("invalid AI after '810'");
					case '27':
						throw new Error("invalid AI after '811'");
					case '28':
						throw new Error("invalid AI after '81'");
					case '29':
						throw new Error("invalid AI after '82'");
					case '30':
						throw new Error("invalid AI after '8'");
					case '31':
						throw new Error("invalid AI after '9'");
					case '32':
						throw new Error("no valid AI");
					case '33':
						throw new Error("invalid year in date");
					case '34':
						throw new Error("invalid month in date");
					case '35':
						throw new Error("invalid day in date");
					case '36':
						throw new Error("invalid number");
					default:
						throw new Error("unknown error");
				}
			}
		}
		/**
		 * ==== Third and last step: =====
		 *
		 */
		return answer;
	},

	$D(value) {
		value = value.toString();
		value = new Date(
			Number(value.substr(0, 4)),
			Number(value.substr(4, 2) - 1),
			Number(value.substr(6, 2)),
			Number(value.substr(8, 2)),
			Number(value.substr(10, 2)),
			Number(value.substr(12, 2))
		);
		return value.getFullYear() > 2091 ? null : dayjs(value).format(consts.MomentFormat.DateTimeFormatAMPM);
	},
	customDateTimeDisplay: (date, dateTimeFormat) => {
		if (date && dateTimeFormat) {
			const cutomizedDateTime = date
				.replace(/[$D{}]/g, '')
				.replace('T', ' ')
				.replace('.000Z', '');
			const displayData = dayjs(cutomizedDateTime).format(dateTimeFormat);
			return displayData;
		}
	},
	CheckSingleValueIconStatus: (metric, actual) => {
		if (actual >= metric) {
			return <DoneIcon fontSize="small" color="success" />;
		} else {
			return <CloseIcon fontSize="small" color="error" />;
		}
	},
	CheckRangeValueIconStatus: (metricMin, actualMin, metricMax, actualMax) => {
		if (actualMin >= metricMin && actualMax <= metricMax) {
			return <DoneIcon fontSize="small" color="success" />;
		} else {
			return <CloseIcon fontSize="small" color="error" />;
		}
	},
	CheckTimeValueIconStatus: (metricMin, actual, metricMax) => {
		const actualTime = dayjs(actual, 'HH:mm:ss');
		const metricMinTime = dayjs(metricMin, 'HH:mm:ss');
		if (metricMax) {
			const metricMaxTime = dayjs(metricMax, 'HH:mm:ss');
			const validate =
				actualTime.isAfter(metricMinTime) ||
				actualTime.isSame(metricMinTime) ||
				actualTime.isBefore(metricMaxTime) ||
				actualTime.isSame(metricMaxTime);
			if (validate === true) {
				return <DoneIcon fontSize="small" color="success" />;
			} else {
				return <CloseIcon fontSize="small" color="error" />;
			}
		} else {
			const validate = actualTime.isAfter(metricMinTime) || actualTime.isSame(metricMinTime);
			if (validate === true) {
				return <DoneIcon fontSize="small" color="success" />;
			} else {
				return <CloseIcon fontSize="small" color="error" />;
			}
		}
	},
	getLoadRelease(tags) {
		const loadRelease = util.localData.LoadReleaseIdAccess || tags?.LoadReleaseId;
		return loadRelease === consts.LoadReleaseType.Parametric;
	},
	renderCIResultIcon(row, property, pathName = '', location = {}) {
		return (
			<>
				{row[property] === 'fa-check' && (
					<IconButton color="success" size="small">
						<CheckCircle fontSize="inherit" />
					</IconButton>
				)}
				{row[property] === 'fa-times' && (
					<IconButton color="error" size="small">
						<Cancel fontSize="inherit" />
					</IconButton>
				)}
				{pathName === location?.pathname ? '' : !row[property] && <Button variant="contained" size="small">{strings.Add}</Button>}
			</>
		);
	},
	renderBIResultIcon(row, pathName = '', location = {}) {
		return (
			<>
				{row.BIResultIcon === consts.BIResultIcon.TestPositive && (
					<IconButton color="error" size="small">
						<Add fontSize="inherit" />
					</IconButton>
				)}
				{row.BIResultIcon === consts.BIResultIcon.TestNegative && (
					<IconButton color="success" size="small">
						<Remove fontSize="inherit" />
					</IconButton>
				)}
				{pathName === location?.pathname
					? ''
					: !row.BIResultIcon && <Button variant="contained" size="small">{strings.Add}</Button>}
			</>
		);
	},
	renderBICIEditButton(row, pathName = '', location = {}) {
		return (
			<Grid container spacing={1} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
				<Grid item>
				<Typography>{row.OperatorName}</Typography>
				</Grid>
				{pathName !== location?.pathname && (
					<Grid item >
						<IconButton color="primary" size="small">
							<Edit fontSize="inherit" />
						</IconButton>
					</Grid>
				)}
			</Grid>
		);
	},
	removeEndoValues(pathName, location) {
		return location.pathname === pathName ? true : false;
	},
	renderAttachmentButton(row, isStrilizer, pathName = '', location = {}) {
		const attachmentCount = row.AttachmentCount || 0;
		return location?.pathname === pathName ? (
			''
		) : attachmentCount !== 0 ? (
			<IconButton
				color="primary"
				size="small"
				component={Link}
				to={encodeURI(
					`/cycleattachmentlist?AssociationId=${isStrilizer ? row.CycleId : row.id}&AssociationTypeId=${1}`
				)}
			>
				<HelpIcon fontSize="inherit" />
			</IconButton>
		) : (
			<Button
				component={Link}
				size="small"
				variant="contained"
				to={encodeURI(
					`/cycleattachmentlist?AssociationId=${isStrilizer ? row.CycleId : row.id}&AttachmentTypeId=${isStrilizer ? 1 : 0
					}&AssociationTypeId=${1}`
				)}
			>
				N/A
			</Button>
		);
	},
	renderStsLotIcon(icon) {
		return (
			<>
				{icon === 'fa-check' && (
					<IconButton color="success" sx={{ padding: 0 }}>
						<CheckCircle fontSize="inherit" padding={0} />
					</IconButton>
				)}
				{icon === 'fa-times' && (
					<IconButton color="error" sx={{ padding: 0 }}>
						<Cancel fontSize="inherit" />
					</IconButton>
				)}
			</>
		);
	},
	getInstrumentData(data, DataProperty) {
		// In dual scope, we get multiple values. Hence this will combine all values for that key
		let val = [];
		for (const row of data.Instrument) {
			if (row[DataProperty]) {
				val.push(row[DataProperty]);
			}
		}
		return (val = val.join(', '));
	},
	unitArrayConverter(data) {
		// Convert buffer data to a Uint8Array
		const uint8Array = new Uint8Array(data);
		// Convert Uint8Array to a Blob
		return new Blob([uint8Array], { type: 'image/png' });
	},
	removeLastComma(input) {
		if (typeof input === 'string' && input.endsWith(',')) {
			return input.slice(0, -1); // Remove the last character (comma)
		}
		return input
	},
	makeFiveDigit(value) { //Genrate Barcode
		// Convert the value to a string
		value = value.toString();
		// Pad the value with zeros to make it 5 digits
		value = value.padStart(5, '0');

		return value;
	},
	isHuluAdmin() {
		const huluAdminRole = ["huluadmin"];
		const currentRole = util.localData?.loginData?.tags.RoleName.toLowerCase();
		return huluAdminRole.includes(currentRole)
	},
	canModify(param) {
		const isTrackingsystem = !param?.gridData?.DataSource || param?.gridData?.DataSource?.match(consts.trackingSystemIdentifierRegax);
		const currentRole = util.localData?.loginData?.tags.RoleName.toLowerCase();
		return rolesAllowedToModify.includes(currentRole) && !isTrackingsystem;
	},
	cannotViewXML() {
		const rolesNotAllowedToViewXML = ["steris specialist", "supervisor", "operator"]
		const currentRole = util.localData?.loginData?.tags.RoleName.toLowerCase();
		return rolesNotAllowedToViewXML.includes(currentRole)
	},
	viewOnly(checkUrl = false, formik = {}, readOnlyRoles, isFromInterfaceConfig = false) {
		readOnlyRoles = readOnlyRoles || ["huluadmin", "operator", "department"];
		const currentRole = util.localData?.loginData?.tags.RoleName.toLowerCase();
		return readOnlyRoles.includes(currentRole) || (checkUrl && window.location.href.includes('quicksearchscope')) || (!!formik?.values?.DataSource?.match(consts.trackingSystemIdentifierRegax) && !isFromInterfaceConfig);
	},
	canAdd({ gridData, activeRecord }) {
		const isTrackingsystem = !gridData?.DataSource && !activeRecord || gridData?.DataSource?.match(consts.trackingSystemIdentifierRegax);
		const currentRole = util.localData?.loginData?.tags.RoleName.toLowerCase();
		return !rolesAllowedToModify.includes(currentRole) || isTrackingsystem;
	},
	isGridReadOnly() {
		if (util.isHuluAdmin()) {
			return false
		} else if (util.viewOnly()) {
			return true
		} else {
			return false
		}
	},
	canPrint() {
		if (util.isHuluAdmin()) {
			return false
		} else if (util.canModify() || util.viewOnly()) {
			return true
		}
	},
	removecommas(value) {
		let newValue = value,
			formattedValue = [];
		newValue &&
			newValue.split(',').forEach((val) => {
				if (val !== '' && val !== undefined) {
					formattedValue.push(val);
				}
			});
		return formattedValue.toString();
	},
	deleteKeys: (data, keysToDelete) => {
		for (const key in data) {
			if (keysToDelete.includes(key)) {
				delete data[key];
			}
		}
		return data;
	},
	formatLocalTime: (type, date) => {
		if (date) {
			const inputDateTime = date;
			const year = inputDateTime.substring(0, 4);
			const month = inputDateTime.substring(4, 6);
			const day = inputDateTime.substring(6, 8);
			const hour = inputDateTime.substring(8, 10);
			const minutes = inputDateTime.substring(10, 12);
			// Convert the hour to 12-hour format and determine AM/PM
			const ampm = parseInt(hour) >= 12 ? 'PM' : 'AM';
			const formattedHour = (parseInt(hour) % 24).toString().padStart(2, '0'); // Convert to 12-hour format and pad with leading zero
			const formattedDateTime =
				type === 'date'
					? `${year}-${month}-${day} ${formattedHour}:${minutes} ${ampm}`
					: `${formattedHour}:${minutes} ${ampm}`;
			return formattedDateTime;
		}
	},
	deviceTypeRenderr: (value) => {
		let formatedValue = [];
		if (Array.isArray(value)) {
			formatedValue = value.map((entry) => consts.DeviceType[entry]).filter(entry => entry !== undefined);
		}
		return formatedValue;
	},
	showError: (message, title, type, customFunction) => {
        document.activeElement.blur();
        Swal.fire({
            title: title,
            text: message,
            icon: type,
            button: strings.Ok,
            confirmButtonText: strings.Ok,
			allowOutsideClick: false,
        }).then((result) => {
              if(typeof customFunction === "function"){
                customFunction();
              }
          });
    },
	isFromTrackingSystem: ({ formik }) => {
		const { values = {} } = formik;
		return !!values?.DataSource?.match(consts.trackingSystemIdentifierRegax);
	},
	isVisible: ({ extraRoleAddOn = [] }) => {
		const currentRole = util.localData?.loginData?.roles[0].toLowerCase();
		const requiredRole = ['supervisor', 'steris specialist', 'operator', ...extraRoleAddOn];
		return !requiredRole.includes(currentRole?.toLowerCase());
	},
	nonSterisHide: (formik) => {
		const { NONSTERISHP, NONSTERISSTEAM } = consts.EquipmentFamilyType;
		const { values } = formik;
		const value = values.EquipmentFamilyId;
		let visible = ![
			NONSTERISSTEAM,
			NONSTERISHP
		].includes(value);

		return visible;
	},
	getCookie: (cname) => {
		let name = cname + '=';
		let decodedCookie = decodeURIComponent(document.cookie);
		let ca = decodedCookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) === ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) === 0) {
				return c.substring(name.length, c.length);
			}
		}
		return '';
	},
	deleteCookie: (name, path, domain) => {
		document.cookie = `${name}=${path ? `;path=${path}` : ''} ${domain ? `;domain=${domain}` : ''};expires=Thu, 01 Jan 1970 00:00:01 GMT`;
	},
	criticalParameterIcon: ({ CriticalParameterIcon = "" }) => {
		return CriticalParameterIcon.includes('fa-check');
	},
	dynamicFormSubmission: ({ body, action }) => {
		const form = document.createElement('form');
		Object.keys(body).forEach(key => {
			const input = document.createElement('input');
			input.type = 'hidden';
			input.name = key;
			input.value = body[key];
			form.appendChild(input);
		});

		form.method = 'POST';
		form.action = action;
		form.target = '_blank';

		document.body.appendChild(form);
		form.submit();
		document.body.removeChild(form);
	},
	isValidFile: (file) => {
		return consts.fileTypes.includes(file.type) ||
			consts.fileExtensionRegex.xlsx.test(file.name) ||
			consts.fileExtensionRegex.strx.test(file.name);
	},
	checkUserRoleAccess: (requiredRoles = []) => {
		const currentRole = util.localData?.loginData?.tags?.RoleName?.toLowerCase();
		requiredRoles = requiredRoles.length ? requiredRoles : ['supervisor', 'steris specialist', 'steris admin', 'superadmin'];
		return requiredRoles.includes(currentRole?.toLowerCase());
	},
	sortObjects: (obj1, obj2, prop) => {
		const value1 = obj1[prop];
		const value2 = obj2[prop];
		const validateProp = [undefined, null];
		if (validateProp.includes(value1)) {
			return 1;
		} else if (validateProp.includes(value2)) {
			return -1;
		} else {
			return value1?.toString().toLowerCase().localeCompare(value2?.toString().toLowerCase())
		}
	},
	onChangeTopic : ({ formik, value, key, topic }) => {
		if (!value.length) {
			const filterdParentTopic = formik.values[key].filter((data) => data !== topic)
			formik.setFieldValue(key, filterdParentTopic)
		}
	},
	onChangeSerialNumber: ({ value }) => {
		const formValue = new FormData();
		formValue.append('otherAction', 'checkSerialNumber');
		formValue.append('action', 'otherAction');
		formValue.append('serialNumber', value);
		fetch(connectionService.ClientRequests, {
			method: 'POST',
			body: formValue,
		})
			.then((res) => res.json())
			.then((json) => {
				const { success } = { ...json };
				if (!success) {
					Swal.fire({
						title: strings.WarningTitle,
						text: strings.SerialNumberNotExist,
						icon: 'warning',
						button: strings.Ok,
						allowOutsideClick: false
					});
				}
			});
	},

	// Determines whether the department should be visible based on the user's role and licensed application.
	// Returns true if the user's role is SuperAdmin, STERISSpecialist, or Supervisor, 
	// and the LicenseAppName includes "catendo".
	isDepartmentVisible: ({ activeRecord }) => {
		const auth = (util.localData && util.localData.loginData) || {};
		const { DeviceTypes } = activeRecord.record;
		return rolesArray.includes(auth.tags.RoleName) &&
			auth.tags.LicenseAppName.includes("catendo") &&
			DeviceTypes.includes("RAER");
	},

	// Returns true if the data source is not a tracking system and the user is not a Hulu admin.
	isAllowImport: (params) => {
		const result = params?.DataSource?.match(consts.trackingSystemIdentifierRegax);
		return !(result || util.isHuluAdmin());
	}
};

export default util;

Array.prototype.getIndexBy = function (name, value) {
	for (let i = 0; i < this.length; i++) {
		if (this[i][name] === value) {
			return i;
		}
	}
	return -1;
}
